import React, { useState, useRef, useEffect, useMemo } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { Redirect } from "react-router-dom";
import TopBar from "../../components/TopBar";
import Sidebar from "../../components/Sidebar";
import { IoChevronUp, IoChevronDown, IoCloudUploadOutline, IoArrowBack, IoCheckmarkCircle, IoWarning, IoDocumentText, IoRocketOutline, IoStatsChart, IoClipboardOutline, IoFolderOpenOutline, IoGridOutline, IoBarChartOutline, IoLayersOutline, IoClose, IoSearch, IoSaveOutline } from "react-icons/io5";
import { HiOutlineDocumentText } from "react-icons/hi";
import { FiEdit2 } from "react-icons/fi";
import { BsRobot } from "react-icons/bs";
import { getAllSurveys, checkSurveyStatus, submitSurvey, uploadSurveyFile, deleteSurveyFile, getSurveyFiles, getAllSurveysTemplate, deploySurveyTemplate } from "../../store/actions/surveyActions";
import { getAllRisks_Report } from "../../store/actions/riskActions";
import { getSOAControls, updateSOAControl } from "../../store/actions/soaActions";
import LOADER from "../../assets/images/loader.svg";
import {
  Users,
  Calendar,
  BarChart2,
  Eye,
  Download
} from "lucide-react";


// Clause 4 questions
const clause4Questions = [
    {
        id: "q4_1",
        text: "ISMS'i etkileyen dış hususlar (yasal, düzenleyici, teknolojik, pazar koşulları vb.) tanımlanmış ve dokümante edilmiş midir?"
    },
    {
        id: "q4_2",
        text: "ISMS'i etkileyen iç hususlar (organizasyon yapısı, kaynaklar, kültür vb.) tanımlanmış ve dokümante edilmiş midir?"
    },
    {
        id: "q4_3",
        text: "İlgili taraflar ve bu tarafların bilgi güvenliği gereksinimleri tanımlanmış mıdır?"
    },
    {
        id: "q4_4",
        text: "ISMS kapsamı tanımlanmış ve dokümante edilmiş midir?"
    },
    {
        id: "q4_5",
        text: "ISMS kapsamı, ilgili paydaşlara iletilmiş ve erişilebilir durumda mıdır?"
    }
];

// Clause 5 questions
const clause5Questions = [
    {
        id: "q5_1",
        text: "Üst yönetim, ISMS için liderlik ve taahhüt göstermekte midir?"
    },
    {
        id: "q5_2",
        text: "ISMS için yeterli kaynaklar (insan, bütçe, zaman) tahsis edilmiş midir?"
    },
    {
        id: "q5_3",
        text: "Bilgi Güvenliği Politikası oluşturulmuş ve onaylanmış mıdır?"
    },
    {
        id: "q5_4",
        text: "Bilgi Güvenliği Politikası, organizasyon genelinde duyurulmuş mudur?"
    }
];

// Clause 6 questions
const clause6Questions = [
    {
        id: "q6_1",
        text: "Tanımlanmış bir bilgi güvenliği risk değerlendirme süreci mevcut mudur?"
    },
    {
        id: "q6_2",
        text: "Riskler gizlilik, bütünlük ve erişilebilirlik (CIA) esas alınarak değerlendirilmekte midir?"
    },
    {
        id: "q6_3",
        text: "Tanımlanan her bilgi güvenliği riski için risk sahibi (risk owner) atanmış mıdır?"
    },
    {
        id: "q6_4",
        text: "Risk değerlendirme sonuçları dokümante edilmiş ve muhafaza edilmekte midir?"
    },
    {
        id: "q6_5",
        text: "Uygulanabilirlik Bildirimi (Statement of Applicability - SoA) hazırlanmış mıdır?"
    },
    {
        id: "q6_6",
        text: "Bilgi güvenliği risk işleme planı hazırlanmış ve onaylanmış mıdır?"
    },
    {
        id: "q6_7",
        text: "Bilgi güvenliği hedefleri tanımlanmış ve dokümante edilmiş midir?"
    }
];

// Clause 7 questions
const clause7Questions = [
    {
        id: "q7_1",
        text: "ISMS için gerekli kaynaklar (personel, altyapı, bütçe) belirlenmiş ve sağlanmış mıdır?"
    },
    {
        id: "q7_2",
        text: "Bilgi güvenliği ile ilgili rollerdeki personelin yetkinlikleri tanımlanmış mıdır?"
    },
    {
        id: "q7_3",
        text: "Personel yetkinlik geliştirme faaliyetleri (eğitim, sertifikasyon vb.) planlanmış ve uygulanmış mıdır?"
    },
    {
        id: "q7_4",
        text: "Tüm çalışanlar bilgi güvenliği politikası ve kendi sorumlulukları hakkında bilgilendirilmiş midir?"
    },
    {
        id: "q7_5",
        text: "Bilgi güvenliği farkındalık programı uygulanmakta mıdır?"
    },
    {
        id: "q7_6",
        text: "İç ve dış paydaşlarla bilgi güvenliği iletişimi için süreçler tanımlanmış mıdır?"
    },
    {
        id: "q7_7",
        text: "ISMS dokümantasyonu (politikalar, prosedürler, kayıtlar) oluşturulmuş ve yönetilmekte midir?"
    },
    {
        id: "q7_8",
        text: "Dokümante edilmiş bilginin kontrolü (erişim, güncelleme, saklama) sağlanmakta mıdır?"
    }
];

// Clause 8 questions
const clause8Questions = [
    {
        id: "q8_1",
        text: "Bilgi güvenliği gereksinimlerini karşılamak için operasyonel süreçler planlanmış ve uygulanmakta mıdır?"
    },
    {
        id: "q8_2",
        text: "Planlanan değişiklikler kontrol altında mı ve istenmeyen değişikliklerin etkileri gözden geçiriliyor mu?"
    },
    {
        id: "q8_3",
        text: "Dış kaynaklı süreçler tanımlanmış ve kontrol altında mıdır?"
    },
    {
        id: "q8_4",
        text: "Bilgi güvenliği risk değerlendirmesi planlı aralıklarla veya önemli değişiklikler olduğunda yapılmakta mıdır?"
    },
    {
        id: "q8_5",
        text: "Risk değerlendirme sonuçları dokümante edilmekte midir?"
    },
    {
        id: "q8_6",
        text: "Bilgi güvenliği risk işleme planı uygulanmakta mıdır?"
    },
    {
        id: "q8_7",
        text: "Risk işleme sonuçları dokümante edilmekte midir?"
    }
];

// Clause 9 questions
const clause9Questions = [
    {
        id: "q9_1",
        text: "Kuruluşunuz, bilgi güvenliği süreçlerini ve kontrollerini nasıl izlemekte ve ölçmektedir? (Madde 9.1a)"
    },
    {
        id: "q9_2",
        text: "Bu süreçlerin ve kontrollerin izlenmesi ve ölçülmesi için hangi yöntemler kullanılmaktadır? (Madde 9.1b)"
    },
    {
        id: "q9_3",
        text: "İzleme ve ölçme yöntemlerinin geçerli, karşılaştırılabilir ve tekrarlanabilir sonuçlar üretmesi nasıl sağlanmaktadır? (Madde 9.1b)"
    },
    {
        id: "q9_4",
        text: "Bilgi güvenliği faaliyetlerinin izlenmesi ve ölçülmesi ne sıklıkla yapılmaktadır? (Madde 9.1c)"
    },
    {
        id: "q9_5",
        text: "Üst yönetim, bilgi güvenliği yönetim sisteminin uygunluğunu, yeterliliğini ve etkinliğini planlı aralıklarla gözden geçirmek üzere yönetim gözden geçirme toplantıları yapıyor mu? (Madde 9.3.1)"
    },
    {
        id: "q9_6",
        text: "Yönetim gözden geçirme sonuçları, BGYS'nin sürekli iyileştirilmesi için fırsatlar ve değişiklik gereksinimleri içeriyor mu? (Madde 9.3.3)"
    }
];

// Clause 10 questions
const clause10Questions = [
    {
        id: "q10_1",
        text: "Kuruluş, Bilgi Güvenliği Yönetim Sisteminin (BGYS) uygunluğunu sürekli olarak iyileştirmek için bir sürece sahip midir? (Madde 10.1)"
    },
    {
        id: "q10_2",
        text: "Bir uygunsuzluk meydana geldiğinde, kuruluş bunu kontrol altına almak ve düzeltmek için derhal aksiyon alır mı? (Madde 10.2 a)1)"
    },
    {
        id: "q10_3",
        text: "Kuruluş, uygunsuzluğun kök neden(ler)ini belirler mi? (Madde 10.2 b)2)"
    },
    {
        id: "q10_4",
        text: "Uygunsuzlukların giderilmesi için alınan düzeltici faaliyetlerin etkinliği gözden geçirilir mi? (Madde 10.2 d)"
    }
];

// All clauses for review
const allClauses = [
    { id: 4, title: "CLAUSE 4 – CONTEXT OF THE ORGANIZATION", subtitle: "Organizasyonun bağlamının anlaşılması", questions: clause4Questions },
    { id: 5, title: "CLAUSE 5 – LEADERSHIP", subtitle: "Liderlik ve taahhüt", questions: clause5Questions },
    { id: 6, title: "CLAUSE 6 – PLANNING", subtitle: "Planlama", questions: clause6Questions },
    { id: 7, title: "CLAUSE 7 – SUPPORT", subtitle: "Destek", questions: clause7Questions },
    { id: 8, title: "CLAUSE 8 – OPERATION", subtitle: "İşletim", questions: clause8Questions },
    { id: 9, title: "CLAUSE 9 – PERFORMANCE EVALUATION", subtitle: "Performans değerlendirmesi", questions: clause9Questions },
    { id: 10, title: "CLAUSE 10 – IMPROVEMENT", subtitle: "İyileştirme", questions: clause10Questions },
];




// Helper to get answer display text
const getAnswerDisplay = (answer) => {
    if (answer === "evet") return { text: "Evet", color: "text-green-600", bgColor: "bg-green-100" };
    if (answer === "hayir") return { text: "Hayır", color: "text-red-600", bgColor: "bg-red-100" };
    return { text: "Cevaplanmadı", color: "text-gray-500", bgColor: "bg-gray-100" };
};

// ISO 27001:2022 SOA Controls (93 controls)
const initialSOAControls = [
    // Organizasyonel Kontroller (5.1 - 5.37)
    { id: '1', controlId: '5.1', controlName: 'Bilgi Güvenliği Politikaları', category: 'Organizasyonel', description: 'Bilgi güvenliği için bir dizi politika tanımlanmalı, yönetim tarafından onaylanmalı, yayınlanmalı, ilgili personel ve ilgili taraflara iletilmeli ve onaylanmalı ve planlı aralıklarla ve önemli değişiklikler meydana geldiğinde gözden geçirilmelidir.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: ['RISK-001', 'RISK-003'] },
    { id: '2', controlId: '5.2', controlName: 'Bilgi Güvenliği Rol ve Sorumlulukları', category: 'Organizasyonel', description: 'Bilgi güvenliği rol ve sorumlulukları, kuruluş ihtiyaçlarına göre tanımlanmalı ve tahsis edilmelidir.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: ['RISK-001'] },
    { id: '3', controlId: '5.3', controlName: 'Görev Ayrımı', category: 'Organizasyonel', description: 'Çelişen görevler ve sorumluluk alanları, kuruluşun varlıklarının yetkisiz veya kasıtsız değiştirilmesi veya kötüye kullanılması fırsatlarını azaltmak için ayrılmalıdır.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: ['RISK-005', 'RISK-012'] },
    { id: '4', controlId: '5.4', controlName: 'Yönetim Sorumlulukları', category: 'Organizasyonel', description: 'Yönetim, tüm personelin kuruluşun belirlenen bilgi güvenliği politikası, konuya özel politikaları ve prosedürleri doğrultusunda bilgi güvenliğini uygulamasını talep etmelidir.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: [] },
    { id: '5', controlId: '5.5', controlName: 'Yetkililerle İletişim', category: 'Organizasyonel', description: 'Kuruluş, ilgili yetkililerle iletişimi kurmalı ve sürdürmelidir.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: [] },
    { id: '6', controlId: '5.6', controlName: 'Özel İlgi Gruplarıyla İletişim', category: 'Organizasyonel', description: 'Kuruluş, özel ilgi grupları veya diğer uzman güvenlik forumları ve profesyonel derneklerle iletişimi kurmalı ve sürdürmelidir.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: [] },
    { id: '7', controlId: '5.7', controlName: 'Tehdit İstihbaratı', category: 'Organizasyonel', description: 'Bilgi güvenliği tehditlerine ilişkin bilgiler toplanmalı ve tehdit istihbaratı üretmek için analiz edilmelidir.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: ['RISK-007', 'RISK-009', 'RISK-021'] },
    { id: '8', controlId: '5.8', controlName: 'Proje Yönetiminde Bilgi Güvenliği', category: 'Organizasyonel', description: 'Bilgi güvenliği, proje yönetimine entegre edilmelidir.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: [] },
    { id: '9', controlId: '5.9', controlName: 'Bilgi ve Diğer İlişkili Varlıkların Envanteri', category: 'Organizasyonel', description: 'Sahipleri de dahil olmak üzere bilgi ve diğer ilişkili varlıkların bir envanteri geliştirilmeli ve sürdürülmelidir.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: ['RISK-002', 'RISK-004'] },
    { id: '10', controlId: '5.10', controlName: 'Bilgi ve Diğer İlişkili Varlıkların Kabul Edilebilir Kullanımı', category: 'Organizasyonel', description: 'Bilgi ve diğer ilişkili varlıkların kabul edilebilir kullanımına ilişkin kurallar ve işleme prosedürleri tanımlanmalı, belgelendirilmeli ve uygulanmalıdır.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: ['RISK-011'] },
    { id: '11', controlId: '5.11', controlName: 'Varlıkların İadesi', category: 'Organizasyonel', description: 'Personel ve uygun diğer ilgili taraflar, istihdam, sözleşme veya anlaşmalarının değişmesi veya sona ermesi üzerine ellerinde bulunan kuruluşa ait tüm varlıkları iade etmelidir.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: [] },
    { id: '12', controlId: '5.12', controlName: 'Bilginin Sınıflandırılması', category: 'Organizasyonel', description: 'Bilgi, gizlilik, bütünlük, kullanılabilirlik ve ilgili taraf gereksinimlerine dayalı olarak kuruluşun bilgi güvenliği ihtiyaçlarına göre sınıflandırılmalıdır.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: ['RISK-002', 'RISK-006'] },
    { id: '13', controlId: '5.13', controlName: 'Bilginin Etiketlenmesi', category: 'Organizasyonel', description: 'Kuruluş tarafından benimsenen bilgi sınıflandırma şemasına uygun olarak bilgi etiketleme için uygun bir prosedür seti geliştirilmeli ve uygulanmalıdır.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: ['RISK-002'] },
    { id: '14', controlId: '5.14', controlName: 'Bilgi Transferi', category: 'Organizasyonel', description: 'Kuruluş içindeki ve kuruluş ile diğer taraflar arasındaki tüm aktarım tesisi türleri için bilgi aktarım kuralları, prosedürleri veya anlaşmaları yürürlükte olmalıdır.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: ['RISK-008', 'RISK-013'] },
    { id: '15', controlId: '5.15', controlName: 'Erişim Kontrolü', category: 'Organizasyonel', description: 'Bilgiye ve diğer ilişkili varlıklara fiziksel ve mantıksal erişimi kontrol etmek için kurallar, iş ve bilgi güvenliği gereksinimlerine dayalı olarak oluşturulmalı ve uygulanmalıdır.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: ['RISK-005', 'RISK-010', 'RISK-012'] },
    { id: '16', controlId: '5.16', controlName: 'Kimlik Yönetimi', category: 'Organizasyonel', description: 'Kimliklerin tam yaşam döngüsü yönetilmelidir.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: ['RISK-010'] },
    { id: '17', controlId: '5.17', controlName: 'Kimlik Doğrulama Bilgileri', category: 'Organizasyonel', description: 'Kimlik doğrulama bilgilerinin tahsisi ve yönetimi, personele kimlik doğrulama bilgilerinin uygun şekilde işlenmesi konusunda tavsiyelerde bulunmayı da içeren bir yönetim süreci tarafından kontrol edilmelidir.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: ['RISK-010', 'RISK-015'] },
    { id: '18', controlId: '5.18', controlName: 'Erişim Hakları', category: 'Organizasyonel', description: 'Bilgiye ve diğer ilişkili varlıklara erişim hakları, kuruluşun erişim kontrolüne ilişkin konuya özel politikası ve kurallarına uygun olarak sağlanmalı, gözden geçirilmeli, değiştirilmeli ve kaldırılmalıdır.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: ['RISK-005', 'RISK-010'] },
    { id: '19', controlId: '5.19', controlName: 'Tedarikçi İlişkilerinde Bilgi Güvenliği', category: 'Organizasyonel', description: 'Tedarikçinin ürün veya hizmetlerinin kullanımıyla ilişkili bilgi güvenliği risklerini yönetmek için süreçler ve prosedürler tanımlanmalı ve uygulanmalıdır.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: ['RISK-016', 'RISK-017'] },
    { id: '20', controlId: '5.20', controlName: 'Tedarikçi Anlaşmalarında Bilgi Güvenliğinin Ele Alınması', category: 'Organizasyonel', description: 'İlgili bilgi güvenliği gereksinimleri, tedarikçi ilişkisinin türüne göre her tedarikçi ile kurulmalı ve üzerinde anlaşılmalıdır.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: ['RISK-016'] },
    { id: '21', controlId: '5.21', controlName: 'BİT Tedarik Zincirinde Bilgi Güvenliğinin Yönetimi', category: 'Organizasyonel', description: 'BİT ürün ve hizmet tedarik zinciri ile ilişkili bilgi güvenliği risklerini yönetmek için süreçler ve prosedürler tanımlanmalı ve uygulanmalıdır.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: ['RISK-016', 'RISK-022'] },
    { id: '22', controlId: '5.22', controlName: 'Tedarikçi Hizmetlerinin İzlenmesi, Gözden Geçirilmesi ve Değişiklik Yönetimi', category: 'Organizasyonel', description: 'Kuruluş, tedarikçi bilgi güvenliği uygulamalarını ve hizmet sunumunu düzenli olarak izlemeli, gözden geçirmeli, değerlendirmeli ve değişiklikleri yönetmelidir.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: [] },
    { id: '23', controlId: '5.23', controlName: 'Bulut Hizmetlerinin Kullanımı için Bilgi Güvenliği', category: 'Organizasyonel', description: 'Bulut hizmetlerinin edinimi, kullanımı, yönetimi ve çıkışı için süreçler, kuruluşun bilgi güvenliği gereksinimlerine uygun olarak oluşturulmalıdır.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: ['RISK-014', 'RISK-016'] },
    { id: '24', controlId: '5.24', controlName: 'Bilgi Güvenliği Olay Yönetimi Planlama ve Hazırlık', category: 'Organizasyonel', description: 'Kuruluş, bilgi güvenliği olay yönetimi süreçlerini, rollerini ve sorumluluklarını tanımlayarak, oluşturarak ve ileterek bilgi güvenliği olaylarını yönetmeye hazırlanmalı ve planlamalıdır.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: ['RISK-019', 'RISK-020'] },
    { id: '25', controlId: '5.25', controlName: 'Bilgi Güvenliği Olaylarının Değerlendirilmesi ve Kararı', category: 'Organizasyonel', description: 'Kuruluş, bilgi güvenliği olaylarını değerlendirmeli ve bunların bilgi güvenliği olayları olarak kategorize edilip edilmeyeceğine karar vermelidir.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: ['RISK-019'] },
    { id: '26', controlId: '5.26', controlName: 'Bilgi Güvenliği Olaylarına Müdahale', category: 'Organizasyonel', description: 'Bilgi güvenliği olaylarına, belgelenmiş prosedürlere uygun olarak müdahale edilmelidir.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: ['RISK-019', 'RISK-020'] },
    { id: '27', controlId: '5.27', controlName: 'Bilgi Güvenliği Olaylarından Öğrenme', category: 'Organizasyonel', description: 'Bilgi güvenliği olaylarından elde edilen bilgiler, bilgi güvenliği kontrollerini güçlendirmek ve iyileştirmek için kullanılmalıdır.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: [] },
    { id: '28', controlId: '5.28', controlName: 'Kanıt Toplama', category: 'Organizasyonel', description: 'Kuruluş, bilgi güvenliği olaylarıyla ilgili kanıtların tanımlanması, toplanması, edinilmesi ve korunması için prosedürler oluşturmalı ve uygulamalıdır.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: [] },
    { id: '29', controlId: '5.29', controlName: 'Kesinti Sırasında Bilgi Güvenliği', category: 'Organizasyonel', description: 'Kuruluş, kesinti sırasında bilgi güvenliğini uygun bir seviyede nasıl sürdüreceğini planlamalıdır.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: [] },
    { id: '30', controlId: '5.30', controlName: 'İş Sürekliliği için BİT Hazırlığı', category: 'Organizasyonel', description: 'BİT hazırlığı, iş sürekliliği hedefleri ve BİT sürekliliği gereksinimlerine dayalı olarak planlanmalı, uygulanmalı, sürdürülmeli ve test edilmelidir.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: [] },
    { id: '31', controlId: '5.31', controlName: 'Yasal, Kanuni, Düzenleyici ve Sözleşmesel Gereksinimler', category: 'Organizasyonel', description: 'Bilgi güvenliği ile ilgili yasal, kanuni, düzenleyici ve sözleşmesel gereksinimler ve kuruluşun bu gereksinimleri karşılama yaklaşımı tanımlanmalı, belgelendirilmeli ve güncel tutulmalıdır.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: [] },
    { id: '32', controlId: '5.32', controlName: 'Fikri Mülkiyet Hakları', category: 'Organizasyonel', description: 'Kuruluş, fikri mülkiyet haklarını korumak için uygun prosedürler uygulamalıdır.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: [] },
    { id: '33', controlId: '5.33', controlName: 'Kayıtların Korunması', category: 'Organizasyonel', description: 'Kayıtlar, kayıp, imha, tahrifat, yetkisiz erişim ve yetkisiz yayınlanmaya karşı korunmalıdır.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: [] },
    { id: '34', controlId: '5.34', controlName: 'Gizlilik ve KKB\'nin Korunması', category: 'Organizasyonel', description: 'Kuruluş, geçerli yasa ve yönetmelikler ile sözleşmesel gereksinimlere göre gizliliğin korunması ve KKB\'nin korunmasına ilişkin gereksinimleri tanımlamalı ve karşılamalıdır.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: [] },
    { id: '35', controlId: '5.35', controlName: 'Bilgi Güvenliğinin Bağımsız İncelemesi', category: 'Organizasyonel', description: 'Kuruluşun bilgi güvenliğini yönetme yaklaşımı ve uygulaması planlı aralıklarla veya önemli değişiklikler meydana geldiğinde bağımsız olarak gözden geçirilmelidir.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: [] },
    { id: '36', controlId: '5.36', controlName: 'Bilgi Güvenliği için Politika, Kural ve Standartlara Uygunluk', category: 'Organizasyonel', description: 'Kuruluşun bilgi güvenliği politikasına, konuya özel politikalarına, kurallarına ve standartlarına uygunluk düzenli olarak gözden geçirilmelidir.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: [] },
    { id: '37', controlId: '5.37', controlName: 'Belgelenmiş İşletim Prosedürleri', category: 'Organizasyonel', description: 'Bilgi işlem tesisleri için işletim prosedürleri belgelendirilmeli ve bunlara ihtiyaç duyan personele sunulmalıdır.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: [] },
    // İnsan Kontrolleri (6.1 - 6.8)
    { id: '38', controlId: '6.1', controlName: 'Tarama', category: 'İnsan', description: 'Personel olacak tüm adaylar üzerinde, kuruluşa katılmadan önce ve sürekli olarak, geçerli yasalar, yönetmelikler ve etik dikkate alınarak arka plan doğrulama kontrolleri yapılmalıdır.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: [] },
    { id: '39', controlId: '6.2', controlName: 'İstihdam Hüküm ve Koşulları', category: 'İnsan', description: 'İstihdam sözleşme anlaşmaları, personelin ve kuruluşun bilgi güvenliği sorumluluklarını belirtmelidir.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: [] },
    { id: '40', controlId: '6.3', controlName: 'Bilgi Güvenliği Farkındalığı, Eğitimi ve Öğretimi', category: 'İnsan', description: 'Kuruluşun personeli ve ilgili ilgili taraflar, iş fonksiyonları için uygun olduğu şekilde, kuruluşun bilgi güvenliği politikası hakkında uygun bilgi güvenliği farkındalığı, eğitimi ve öğretimi almalıdır.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: [] },
    { id: '41', controlId: '6.4', controlName: 'Disiplin Süreci', category: 'İnsan', description: 'Bilgi güvenliği politikası ihlali yapan personel ve diğer ilgili taraflara karşı önlem almak için disiplin süreci resmileştirilmeli ve iletilmelidir.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: [] },
    { id: '42', controlId: '6.5', controlName: 'İstihdamın Sona Ermesi veya Değişikliği Sonrası Sorumluluklar', category: 'İnsan', description: 'İstihdamın sona ermesi veya değişikliği sonrasında geçerli kalan bilgi güvenliği sorumlulukları ve görevleri tanımlanmalı ve uygulanmalıdır.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: [] },
    { id: '43', controlId: '6.6', controlName: 'Gizlilik veya Açıklamama Anlaşmaları', category: 'İnsan', description: 'Kuruluşun bilginin korunması ihtiyaçlarını yansıtan gizlilik veya açıklamama anlaşmaları tanımlanmalı ve belgelendirilmelidir.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: [] },
    { id: '44', controlId: '6.7', controlName: 'Uzaktan Çalışma', category: 'İnsan', description: 'Personel uzaktan çalışırken, kuruluşun tesisleri dışında erişilen, işlenen veya depolanan bilgileri korumak için güvenlik önlemleri uygulanmalıdır.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: [] },
    { id: '45', controlId: '6.8', controlName: 'Bilgi Güvenliği Olaylarının Raporlanması', category: 'İnsan', description: 'Kuruluş, personelin gözlemlenen veya şüphelenilen bilgi güvenliği olaylarını uygun kanallar aracılığıyla zamanında raporlaması için bir mekanizma sağlamalıdır.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: [] },
    // Fiziksel Kontroller (7.1 - 7.14)
    { id: '46', controlId: '7.1', controlName: 'Fiziksel Güvenlik Çevreleri', category: 'Fiziksel', description: 'Bilgi ve diğer ilişkili varlıkları içeren alanları korumak için güvenlik çevreleri tanımlanmalı ve kullanılmalıdır.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: [] },
    { id: '47', controlId: '7.2', controlName: 'Fiziksel Giriş', category: 'Fiziksel', description: 'Güvenli alanlar, uygun giriş kontrolleri ve erişim noktaları ile korunmalıdır.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: [] },
    { id: '48', controlId: '7.3', controlName: 'Ofis, Oda ve Tesislerin Güvenliğinin Sağlanması', category: 'Fiziksel', description: 'Ofisler, odalar ve tesisler için fiziksel güvenlik tasarlanmalı ve uygulanmalıdır.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: [] },
    { id: '49', controlId: '7.4', controlName: 'Fiziksel Güvenlik İzleme', category: 'Fiziksel', description: 'Tesisler, yetkisiz fiziksel erişim için sürekli olarak izlenmelidir.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: [] },
    { id: '50', controlId: '7.5', controlName: 'Fiziksel ve Çevresel Tehditlere Karşı Koruma', category: 'Fiziksel', description: 'Doğal afetler ve diğer kasıtlı veya kasıtsız fiziksel tehditler gibi fiziksel ve çevresel tehditlere karşı altyapı koruması tasarlanmalı ve uygulanmalıdır.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: [] },
    { id: '51', controlId: '7.6', controlName: 'Güvenli Alanlarda Çalışma', category: 'Fiziksel', description: 'Güvenli alanlarda çalışma için güvenlik önlemleri tasarlanmalı ve uygulanmalıdır.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: [] },
    { id: '52', controlId: '7.7', controlName: 'Temiz Masa ve Temiz Ekran', category: 'Fiziksel', description: 'Kağıtlar ve çıkarılabilir depolama ortamları için temiz masa kuralları ve bilgi işlem tesisleri için temiz ekran kuralları tanımlanmalı ve uygulanmalıdır.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: [] },
    { id: '53', controlId: '7.8', controlName: 'Ekipman Yerleştirme ve Koruma', category: 'Fiziksel', description: 'Ekipman güvenli bir şekilde yerleştirilmeli ve korunmalıdır.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: [] },
    { id: '54', controlId: '7.9', controlName: 'Tesis Dışı Varlıkların Güvenliği', category: 'Fiziksel', description: 'Tesis dışı varlıklar korunmalıdır.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: [] },
    { id: '55', controlId: '7.10', controlName: 'Depolama Ortamı', category: 'Fiziksel', description: 'Depolama ortamı, kuruluşun sınıflandırma şeması ve işleme gereksinimlerine uygun olarak yönetilmelidir.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: [] },
    { id: '56', controlId: '7.11', controlName: 'Destekleyici Hizmetler', category: 'Fiziksel', description: 'Bilgi işlem tesisleri, güç kesintilerinden ve destekleyici hizmetlerdeki arızalardan kaynaklanan diğer kesintilerden korunmalıdır.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: [] },
    { id: '57', controlId: '7.12', controlName: 'Kablolama Güvenliği', category: 'Fiziksel', description: 'Güç, veri veya bilgi hizmetlerini destekleyen kablolar dinleme, müdahale veya hasardan korunmalıdır.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: [] },
    { id: '58', controlId: '7.13', controlName: 'Ekipman Bakımı', category: 'Fiziksel', description: 'Ekipman, bilginin kullanılabilirliğini, bütünlüğünü ve gizliliğini sağlamak için doğru şekilde bakımı yapılmalıdır.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: [] },
    { id: '59', controlId: '7.14', controlName: 'Ekipmanın Güvenli İmhası veya Yeniden Kullanımı', category: 'Fiziksel', description: 'Depolama ortamı içeren ekipman öğeleri, imha veya yeniden kullanımdan önce doğrulanmalıdır.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: [] },
    // Teknolojik Kontroller (8.1 - 8.34)
    { id: '60', controlId: '8.1', controlName: 'Kullanıcı Uç Nokta Cihazları', category: 'Teknolojik', description: 'Kullanıcı uç nokta cihazlarında depolanan, işlenen veya bunlar aracılığıyla erişilebilen bilgiler korunmalıdır.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: [] },
    { id: '61', controlId: '8.2', controlName: 'Ayrıcalıklı Erişim Hakları', category: 'Teknolojik', description: 'Ayrıcalıklı erişim haklarının tahsisi ve kullanımı kısıtlanmalı ve yönetilmelidir.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: ['RISK-005', 'RISK-012'] },
    { id: '62', controlId: '8.3', controlName: 'Bilgi Erişim Kısıtlaması', category: 'Teknolojik', description: 'Bilgiye ve diğer ilişkili varlıklara erişim, oluşturulan erişim kontrolüne ilişkin konuya özel politikaya uygun olarak kısıtlanmalıdır.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: ['RISK-005', 'RISK-006'] },
    { id: '63', controlId: '8.4', controlName: 'Kaynak Koduna Erişim', category: 'Teknolojik', description: 'Kaynak kod, geliştirme araçları ve yazılım kütüphanelerine okuma ve yazma erişimi uygun şekilde yönetilmelidir.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: ['RISK-023'] },
    { id: '64', controlId: '8.5', controlName: 'Güvenli Kimlik Doğrulama', category: 'Teknolojik', description: 'Güvenli kimlik doğrulama teknolojileri ve prosedürleri uygulanmalıdır.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: ['RISK-010', 'RISK-015'] },
    { id: '65', controlId: '8.6', controlName: 'Kapasite Yönetimi', category: 'Teknolojik', description: 'Kaynakların kullanımı, mevcut ve beklenen kapasite gereksinimlerine uygun olarak izlenmeli ve ayarlanmalıdır.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: [] },
    { id: '66', controlId: '8.7', controlName: 'Kötü Amaçlı Yazılımlara Karşı Koruma', category: 'Teknolojik', description: 'Kötü amaçlı yazılımlara karşı koruma uygulanmalı ve uygun kullanıcı farkındalığı ile desteklenmelidir.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: ['RISK-007', 'RISK-009'] },
    { id: '67', controlId: '8.8', controlName: 'Teknik Zafiyetlerin Yönetimi', category: 'Teknolojik', description: 'Kullanımdaki bilgi sistemlerinin teknik zafiyetleri hakkında bilgi elde edilmeli ve uygun önlemler alınmalıdır.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: ['RISK-021', 'RISK-024'] },
    { id: '68', controlId: '8.9', controlName: 'Konfigürasyon Yönetimi', category: 'Teknolojik', description: 'Donanım, yazılım, hizmetler ve ağların güvenlik konfigürasyonları oluşturulmalı ve yönetilmelidir.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: ['RISK-024'] },
    { id: '69', controlId: '8.10', controlName: 'Bilgi Silme', category: 'Teknolojik', description: 'Bilgi sistemlerinde depolanan bilgiler, artık gerekli olmadığında silinmelidir.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: [] },
    { id: '70', controlId: '8.11', controlName: 'Veri Maskeleme', category: 'Teknolojik', description: 'Veri maskeleme, kuruluşun erişim kontrolüne ilişkin konuya özel politikasına uygun olarak kullanılmalıdır.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: [] },
    { id: '71', controlId: '8.12', controlName: 'Veri Sızıntısı Önleme', category: 'Teknolojik', description: 'Hassas bilgileri işleyen sistemlere veri sızıntısı önleme önlemleri uygulanmalıdır.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: ['RISK-008', 'RISK-013'] },
    { id: '72', controlId: '8.13', controlName: 'Bilgi Yedekleme', category: 'Teknolojik', description: 'Bilgi, yazılım ve sistemlerin yedek kopyaları sürdürülmeli ve düzenli olarak test edilmelidir.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: ['RISK-020', 'RISK-025'] },
    { id: '73', controlId: '8.14', controlName: 'Bilgi İşlem Tesislerinin Yedekliliği', category: 'Teknolojik', description: 'Bilgi işlem tesisleri, kullanılabilirlik gereksinimlerini karşılamaya yeterli yedeklilik ile uygulanmalıdır.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: [] },
    { id: '74', controlId: '8.15', controlName: 'Günlük Kaydı', category: 'Teknolojik', description: 'Aktiviteleri, istisnaları, hataları ve diğer ilgili olayları kaydeden günlükler üretilmeli ve analiz edilmelidir.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: [] },
    { id: '75', controlId: '8.16', controlName: 'İzleme Faaliyetleri', category: 'Teknolojik', description: 'Ağlar, sistemler ve uygulamalar anormal davranışlar için izlenmelidir.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: [] },
    { id: '76', controlId: '8.17', controlName: 'Saat Senkronizasyonu', category: 'Teknolojik', description: 'Kuruluş tarafından kullanılan bilgi işlem sistemlerinin saatleri, onaylanmış zaman kaynaklarıyla senkronize edilmelidir.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: [] },
    { id: '77', controlId: '8.18', controlName: 'Ayrıcalıklı Yardımcı Programların Kullanımı', category: 'Teknolojik', description: 'Sistem ve uygulama kontrollerini geçersiz kılabilen yardımcı programların kullanımı kısıtlanmalıdır.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: [] },
    { id: '78', controlId: '8.19', controlName: 'İşletim Sistemlerine Yazılım Kurulumu', category: 'Teknolojik', description: 'İşletim sistemlerine yazılım kurulumunu güvenli bir şekilde yönetmek için prosedürler uygulanmalıdır.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: [] },
    { id: '79', controlId: '8.20', controlName: 'Ağlar Güvenliği', category: 'Teknolojik', description: 'Ağlar ve ağ cihazları, sistemlerdeki ve uygulamalardaki bilgileri korumak için güvenli hale getirilmelidir.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: [] },
    { id: '80', controlId: '8.21', controlName: 'Ağ Hizmetlerinin Güvenliği', category: 'Teknolojik', description: 'Ağ hizmetlerinin güvenlik mekanizmaları, hizmet seviyeleri ve gereksinimleri tanımlanmalıdır.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: [] },
    { id: '81', controlId: '8.22', controlName: 'Ağların Ayrılması', category: 'Teknolojik', description: 'Bilgi hizmeti grupları, kullanıcılar ve bilgi sistemleri, kuruluşun ağlarında ayrılmalıdır.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: [] },
    { id: '82', controlId: '8.23', controlName: 'Web Filtreleme', category: 'Teknolojik', description: 'Kötü amaçlı içeriğe maruz kalmayı azaltmak için harici web sitelerine erişim yönetilmelidir.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: [] },
    { id: '83', controlId: '8.24', controlName: 'Kriptografinin Kullanımı', category: 'Teknolojik', description: 'Kriptografik anahtar yönetimi de dahil olmak üzere kriptografinin etkili kullanımına ilişkin kurallar tanımlanmalıdır.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: [] },
    { id: '84', controlId: '8.25', controlName: 'Güvenli Geliştirme Yaşam Döngüsü', category: 'Teknolojik', description: 'Yazılım ve sistemlerin güvenli geliştirilmesi için kurallar oluşturulmalıdır.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: [] },
    { id: '85', controlId: '8.26', controlName: 'Uygulama Güvenliği Gereksinimleri', category: 'Teknolojik', description: 'Uygulama geliştirirken veya edinirken bilgi güvenliği gereksinimleri tanımlanmalıdır.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: [] },
    { id: '86', controlId: '8.27', controlName: 'Güvenli Sistem Mimarisi ve Mühendislik İlkeleri', category: 'Teknolojik', description: 'Güvenli sistem mühendisliği için ilkeler oluşturulmalı ve belgelendirilmelidir.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: [] },
    { id: '87', controlId: '8.28', controlName: 'Güvenli Kodlama', category: 'Teknolojik', description: 'Güvenli kodlama ilkeleri yazılım geliştirmeye uygulanmalıdır.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: [] },
    { id: '88', controlId: '8.29', controlName: 'Geliştirme ve Kabul Aşamasında Güvenlik Testi', category: 'Teknolojik', description: 'Güvenlik test süreçleri, geliştirme yaşam döngüsünde tanımlanmalı ve uygulanmalıdır.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: [] },
    { id: '89', controlId: '8.30', controlName: 'Dış Kaynaklı Geliştirme', category: 'Teknolojik', description: 'Kuruluş, dış kaynaklı sistem geliştirmeyle ilgili faaliyetleri yönlendirmeli ve izlemelidir.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: [] },
    { id: '90', controlId: '8.31', controlName: 'Geliştirme, Test ve Üretim Ortamlarının Ayrılması', category: 'Teknolojik', description: 'Geliştirme, test ve üretim ortamları ayrılmalı ve güvenli hale getirilmelidir.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: [] },
    { id: '91', controlId: '8.32', controlName: 'Değişiklik Yönetimi', category: 'Teknolojik', description: 'Bilgi işlem tesislerinde ve bilgi sistemlerinde yapılan değişiklikler, değişiklik yönetimi prosedürlerine tabi olmalıdır.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: [] },
    { id: '92', controlId: '8.33', controlName: 'Test Bilgisi', category: 'Teknolojik', description: 'Test bilgisi uygun şekilde seçilmeli, korunmalı ve yönetilmelidir.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: [] },
    { id: '93', controlId: '8.34', controlName: 'Denetim Testi Sırasında Bilgi Sistemlerinin Korunması', category: 'Teknolojik', description: 'İşletim sistemlerinin değerlendirmesini içeren denetim testleri planlanmalı ve üzerinde anlaşılmalıdır.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: [] },
];

// Category badge color helper
const getCategoryBadgeClass = (category) => {
    switch (category) {
        case 'Organizasyonel': return 'bg-blue-100 text-blue-700 border-blue-200';
        case 'İnsan': return 'bg-purple-100 text-purple-700 border-purple-200';
        case 'Fiziksel': return 'bg-orange-100 text-orange-700 border-orange-200';
        case 'Teknolojik': return 'bg-green-100 text-green-700 border-green-200';
        default: return 'bg-gray-100 text-gray-700 border-gray-200';
    }
};

// Implementation status options
const implementationStatusOptions = [
    { value: 'not-set', label: 'Belirlenmedi', color: 'bg-gray-100 text-gray-600' },
    { value: 'implemented', label: 'Uygulandı', color: 'bg-green-100 text-green-700' },
    { value: 'partial', label: 'Kısmen Uygulandı', color: 'bg-yellow-100 text-yellow-700' },
    { value: 'planned', label: 'Planlandı', color: 'bg-blue-100 text-blue-700' },
    { value: 'not-implemented', label: 'Uygulanmadı', color: 'bg-red-100 text-red-700' },
];

const getImplementationStatusDisplay = (status) => {
    const option = implementationStatusOptions.find(o => o.value === status);
    return option || implementationStatusOptions[0];
};

function FileUploadSection({ questionId, files, onFilesChange, onFileUpload, onFileRemove, survey_id }) {
    const [isDragging, setIsDragging] = useState(false);
    const [uploading, setUploading] = useState(false);
    const [activeUploadTab, setActiveUploadTab] = useState('manuel'); // 'manuel' or 'raboya'

    const handleDragOver = (e) => {
        e.preventDefault();
        setIsDragging(true);
    };

    const handleDragLeave = (e) => {
        e.preventDefault();
        setIsDragging(false);
    };

    const handleDrop = async (e) => {
        e.preventDefault();
        setIsDragging(false);
        const droppedFiles = Array.from(e.dataTransfer.files);
        await uploadFiles(droppedFiles);
    };

    const handleFileSelect = async (e) => {
        const selectedFiles = Array.from(e.target.files);
        await uploadFiles(selectedFiles);
        e.target.value = ''; // Reset input
    };

    const uploadFiles = async (filesToUpload) => {
        setUploading(true);
        //console.log("Survey Upload ", survey_id)
        try {
            for (const file of filesToUpload) {
                //console.log("Survey Upload ", survey_id)
                const result = await onFileUpload(file, questionId, survey_id);
                if (result.success) {
                    // Add the uploaded file info to state
                    const uploadedFile = {
                        name: result.fileName || file.name,
                        size: file.size,
                        url: result.file,
                        uploaded: true
                    };
                    onFilesChange(questionId, [...(files || []), uploadedFile]);
                }
            }
        } catch (error) {
            console.error("Error uploading files:", error);
        } finally {
            setUploading(false);
        }
    };

    const removeFile = async (index) => {
        const file = files[index];
        if (file.id && onFileRemove) {
            try {
                await onFileRemove(file.id);
            } catch (error) {
                console.error("Error removing file:", error);
            }
        }
        const newFiles = [...files];
        newFiles.splice(index, 1);
        onFilesChange(questionId, newFiles);
    };

    const handleRaboyaAsk = () => {
        // Dummy function - does nothing for now
        //console.log("Raboya'ya Sor clicked - feature coming soon");
    };

    return (
        <div className="mt-4 bg-gray-50 rounded-lg p-4 border border-gray-200">
            <div className="flex items-center gap-2 mb-2">
                <HiOutlineDocumentText className="text-gray-600" size={20} />
                <span className="font-medium text-gray-800">Kanıt Toplama</span>
            </div>
            <p className="text-sm text-gray-500 mb-3">Manuel yükleme veya AI destekli otomatik kanıt toplama</p>

            {/* Tabs - Manuel Yükleme and Raboya Sor */}
            <div className="flex items-center gap-4 mb-4 border-b border-gray-200">
                <button
                    onClick={() => setActiveUploadTab('manuel')}
                    className={`flex items-center gap-2 px-3 py-2 font-medium text-sm transition-colors ${activeUploadTab === 'manuel'
                        ? 'text-blue-600 border-b-2 border-blue-600'
                        : 'text-gray-500 hover:text-gray-700 border-b-2 border-transparent'
                        }`}
                >
                    <IoCloudUploadOutline size={18} />
                    Manuel Yükleme
                </button>
                <button
                    onClick={() => setActiveUploadTab('raboya')}
                    className={`flex items-center gap-2 px-3 py-2 font-medium text-sm transition-colors ${activeUploadTab === 'raboya'
                        ? 'text-blue-600 border-b-2 border-blue-600'
                        : 'text-gray-500 hover:text-gray-700 border-b-2 border-transparent'
                        }`}
                >
                    <BsRobot size={18} />
                    Raboya Sor
                </button>
            </div>

            {/* Manuel Yükleme Tab Content */}
            {activeUploadTab === 'manuel' && (
                <>
                    {/* Upload Area */}
                    <div
                        className={`border-2 border-dashed rounded-lg p-8 text-center transition-colors ${isDragging ? "border-blue-400 bg-blue-50" : "border-gray-300 bg-white"
                            } ${uploading ? "opacity-50 pointer-events-none" : ""}`}
                        onDragOver={handleDragOver}
                        onDragLeave={handleDragLeave}
                        onDrop={handleDrop}
                    >
                        <div className="flex flex-col items-center">
                            <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mb-4">
                                <IoCloudUploadOutline size={32} className="text-gray-400" />
                            </div>
                            {uploading ? (
                                <p className="text-gray-700 mb-3">Yükleniyor...</p>
                            ) : (
                                <p className="text-gray-700 mb-3">Dosyaları buraya sürükleyin veya</p>
                            )}
                            <label className={`cursor-pointer ${uploading ? "pointer-events-none" : ""}`}>
                                <span className="bg-blue-600 text-white px-6 py-2 rounded-lg font-medium hover:bg-blue-700 transition-colors inline-flex items-center gap-2">
                                    <IoCloudUploadOutline size={18} />
                                    {uploading ? "Yükleniyor..." : "Dosya Seç"}
                                </span>
                                <input
                                    type="file"
                                    multiple
                                    className="hidden"
                                    onChange={handleFileSelect}
                                    accept=".pdf,.doc,.docx,.xls,.xlsx,.png,.jpg,.jpeg,.gif,.zip"
                                    disabled={uploading}
                                />
                            </label>
                            <p className="text-sm text-gray-500 mt-3">PDF, Word, Excel, Resim, ZIP dosyaları desteklenir</p>
                        </div>
                    </div>

                    {/* Uploaded Files List */}
                    {files && files.length > 0 && (
                        <div className="mt-4 space-y-2">
                            {files.map((file, index) => (
                                <div key={index} className="flex items-center justify-between bg-white border border-gray-200 rounded-lg px-3 py-2">
                                    <div className="flex items-center gap-2">
                                        <HiOutlineDocumentText className="text-gray-500" size={18} />
                                        <span className="text-sm text-gray-700">{file.name}</span>
                                        {file.size && <span className="text-xs text-gray-400">({(file.size / 1024).toFixed(1)} KB)</span>}
                                        {file.uploaded && <span className="text-xs text-green-600">✓ Yüklendi</span>}
                                    </div>
                                    <button
                                        onClick={() => removeFile(index)}
                                        className="text-red-500 hover:text-red-700 text-sm"
                                    >
                                        Kaldır
                                    </button>
                                </div>
                            ))}
                        </div>
                    )}
                </>
            )}

            {/* Raboya Sor Tab Content */}
            {activeUploadTab === 'raboya' && (
                <div className="bg-white rounded-lg p-6 border border-gray-200">
                    <div className="flex items-start gap-4">
                        <div className="w-14 h-14 bg-blue-50 rounded-xl flex items-center justify-center flex-shrink-0">
                            <BsRobot size={28} className="text-blue-600" />
                        </div>
                        <div className="flex-1">
                            <h4 className="text-lg font-semibold text-gray-900 mb-2">Raboya ile Kanıt Toplama</h4>
                            <p className="text-gray-600 text-sm leading-relaxed mb-4">
                                Raboya AI asistanı, bağlı GRC araçlarınızdan (örn: Compliance Manager, Risk Register) bu kontrole uygun kanıtları otomatik olarak bulup toplayacak.
                            </p>
                            <button
                                onClick={handleRaboyaAsk}
                                className="inline-flex items-center gap-2 bg-blue-600 text-white px-5 py-2.5 rounded-lg font-medium hover:bg-blue-700 transition-colors"
                            >
                                <BsRobot size={18} />
                                Raboya'ya Sor
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

function QuestionItem({ question, answer, onAnswerChange, files, onFilesChange, onFileUpload, onFileRemove, survey_id }) {
    return (
        <div className="py-4 border-b border-gray-100 last:border-b-0">
            <label className="block text-gray-800 mb-2">
                {question.text} <span className="text-red-500">*</span>
            </label>
            <div className="relative">
                <select
                    value={answer || ""}
                    onChange={(e) => onAnswerChange(question.id, e.target.value)}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg appearance-none bg-white text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent cursor-pointer"
                >
                    <option value="">Seçiniz</option>
                    <option value="evet">Evet</option>
                    <option value="hayir">Hayır</option>
                </select>
                <IoChevronDown className="absolute right-4 top-1/2 transform -translate-y-1/2 text-gray-400 pointer-events-none" size={20} />
            </div>

            {/* Show file upload only when Evet is selected */}
            {answer === "evet" && (
                <FileUploadSection
                    questionId={question.id}
                    files={files}
                    onFilesChange={onFilesChange}
                    onFileUpload={onFileUpload}
                    onFileRemove={onFileRemove}
                    survey_id={survey_id}
                />
            )}
        </div>
    );
}

function Survey(props) {
    const {  surveys, getAllSurveysFN, deploySurveyTemplateFN, templatesRaw, getAllSurveysTemplateFN, token, checkSurveyStatusFN, submitSurveyFN, uploadSurveyFileFN, deleteSurveyFileFN, getSurveyFilesFN, getAllRisksFN, allRisks, getSOAControlsFN, updateSOAControlFN } = props;

    // Ref for scroll container
    const scrollContainerRef = useRef(null);

    // Loading state
    const [loading, setLoading] = useState(false);
    const [submitting, setSubmitting] = useState(false);

    // Already submitted state
    const [alreadySubmitted, setAlreadySubmitted] = useState(false);
    const [submittedSurvey, setSubmittedSurvey] = useState(null);

    // Current view: 'survey' or 'review' or 'success'
    const [currentView, setCurrentView] = useState('survey');

    // Active tab: 'survey' or 'files'
    const [activeTab, setActiveTab] = useState('survey');

    // Validation error state
    const [validationError, setValidationError] = useState(null);

    // Organization info
    const [orgName, setOrgName] = useState("");
    const [fillerName, setFillerName] = useState("");

    // Answers state - keyed by question id
    const [answers, setAnswers] = useState({});

    // Files state - keyed by question id
    const [files, setFiles] = useState({});

    // SOA state
    const [soaControls, setSoaControls] = useState([]);
    const [soaLoading, setSoaLoading] = useState(true);
    const [soaSearch, setSoaSearch] = useState('');
    const [soaApplicabilityFilter, setSoaApplicabilityFilter] = useState('all');
    const [soaStatusFilter, setSoaStatusFilter] = useState('all');
    const [soaEditModal, setSoaEditModal] = useState(null);
    const [soaEditData, setSoaEditData] = useState(null);
    const [soaSaving, setSoaSaving] = useState(false);
    const [newRiskId, setNewRiskId] = useState('');


    const [templates, setTemplates] = useState([]);
    const [selectedTemplateId, setSelectedTemplateId] = useState(null);
    const [allClausesnew, setAllClauses] = useState([]);

    // Check survey status, load files, and fetch risks on mount
    useEffect(() => {
        const checkStatusAndLoadFiles = async () => {
            try {
                const result = await checkSurveyStatusFN();
                if (result.hasSubmitted) {
                    setAlreadySubmitted(true);
                    setSubmittedSurvey(result.survey);
                    // Populate answers from the submitted survey
                    if (result.survey.answers) {
                        setAnswers(result.survey.answers);
                    }
                    // Populate organization and filler name
                    if (result.survey.organizationName) {
                        setOrgName(result.survey.organizationName);
                    }
                    if (result.survey.fillerName) {
                        setFillerName(result.survey.fillerName);
                    }
                }

                // Fetch existing files for this user
                const existingFiles = await getSurveyFilesFN();
                if (existingFiles && existingFiles.length > 0) {
                    // Group files by question_id
                    const filesGrouped = {};
                    existingFiles.forEach(file => {
                        const questionId = file.survey_question_id;
                        if (questionId) {
                            if (!filesGrouped[questionId]) {
                                filesGrouped[questionId] = [];
                            }
                            filesGrouped[questionId].push({
                                id: file.id,
                                name: file.name,
                                size: file.size,
                                url: file.s3_path,
                                uploaded: true
                            });
                        }
                    });
                    setFiles(filesGrouped);
                }
            } catch (error) {
                console.error("Error checking survey status:", error);
            } finally {
                setLoading(false);
            }
        };
        checkStatusAndLoadFiles();

        // Fetch all risks for SOA assignment
        getAllRisksFN();
    }, [checkSurveyStatusFN, getSurveyFilesFN, getAllRisksFN]);

    // Fetch SOA controls from database
    useEffect(() => {
        const fetchSOAControls = async () => {
            try {
                setSoaLoading(true);
                const controls = await getSOAControlsFN();
                if (controls && controls.length > 0) {
                    // Transform to match the expected format
                    const transformedControls = controls.map(c => ({
                        id: c.soa_id.toString(),
                        soaId: c.soa_id,
                        controlId: c.control_id,
                        controlName: c.control_name,
                        category: c.category,
                        description: c.description,
                        applicable: c.applicable,
                        justification: c.justification || '',
                        implementationStatus: c.implementation_status || 'not-set',
                        riskIds: c.risks ? c.risks.map(r => `RISK-${String(r.id).padStart(3, '0')}`) : []
                    }));
                    setSoaControls(transformedControls);
                } else {
                    // Fallback to initial controls if database is empty
                    setSoaControls(initialSOAControls);
                }
            } catch (error) {
                console.error("Error fetching SOA controls:", error);
                // Fallback to initial controls on error
                setSoaControls(initialSOAControls);
            } finally {
                setSoaLoading(false);
            }
        };
        fetchSOAControls();
    }, [getSOAControlsFN]);

    // Section collapse state
    const [clause4Open, setClause4Open] = useState(true);
    const [clause5Open, setClause5Open] = useState(true);
    const [clause6Open, setClause6Open] = useState(true);
    const [clause7Open, setClause7Open] = useState(true);
    const [clause8Open, setClause8Open] = useState(true);
    const [clause9Open, setClause9Open] = useState(true);
    const [clause10Open, setClause10Open] = useState(true);





    useEffect(() => {
        if (getAllSurveysTemplateFN) {
            getAllSurveysTemplateFN()
        }
    }, [getAllSurveysTemplateFN]);

    useEffect(() => {
        if (getAllSurveysFN) {
            getAllSurveysFN()
        }
    }, [getAllSurveysFN]);

    const scrollToTop = () => {
        if (scrollContainerRef.current) {
            scrollContainerRef.current.scrollTo({ top: 0, behavior: 'smooth' });
        }
    };

    const handleAnswerChange = (questionId, value) => {
        setAnswers(prev => ({ ...prev, [questionId]: value }));
        // Clear validation error when user starts answering
        if (validationError) setValidationError(null);
        // Clear files if answer is not "evet"
        if (value !== "evet") {
            setFiles(prev => {
                const newFiles = { ...prev };
                delete newFiles[questionId];
                return newFiles;
            });
        }
    };

    const handleFilesChange = (questionId, newFiles) => {
        setFiles(prev => ({ ...prev, [questionId]: newFiles }));
    };

    const validateSurvey = () => {
        // Check organization info
        if (!orgName.trim()) {
            return "Lütfen organizasyon adını giriniz.";
        }
        if (!fillerName.trim()) {
            return "Lütfen anketi dolduran kişinin adını giriniz.";
        }

        // Check all questions are answered
        const allQuestionIds = allClauses.flatMap(clause => clause.questions.map(q => q.id));
        const unansweredQuestions = allQuestionIds.filter(id => !answers[id]);

        if (unansweredQuestions.length > 0) {
            return `Lütfen tüm soruları cevaplayınız. ${unansweredQuestions.length} soru cevaplanmamış.`;
        }

        return null; // No errors
    };

    const handleGoToReview = () => {
        const error = validateSurvey();
        if (error) {
            setValidationError(error);
            scrollToTop();
            return;
        }
        setValidationError(null);
        setCurrentView('review');
        // Use setTimeout to ensure state update happens before scroll
        setTimeout(() => scrollToTop(), 0);
    };

    const handleViewDeployment = (d) => {
        //console.log(d)
    };

    const handleExportDeployment = (d) => {
        //console.log(d)
    };

    const handleBackToSurvey = () => {
        setCurrentView('survey');
        setTimeout(() => scrollToTop(), 0);
    };

    const handleFinalSubmit = async () => {
        setSubmitting(true);
        try {
            const surveyData = {
                organizationName: orgName,
                fillerName: fillerName,
                answers: answers
            };

            const result = await submitSurveyFN(surveyData);

            if (result.success) {
                setCurrentView('success');
                scrollToTop();
            }
        } catch (error) {
            console.error("Error submitting survey:", error);
            if (error.response?.data?.alreadySubmitted) {
                setAlreadySubmitted(true);
                setSubmittedSurvey(error.response.data.survey);
            } else {
                setValidationError("Anket gönderilirken bir hata oluştu. Lütfen tekrar deneyin.");
            }
        } finally {
            setSubmitting(false);
        }
    };

    // Calculate stats for review
    const getTotalQuestions = () => {
        return allClauses.reduce((acc, clause) => acc + clause.questions.length, 0);
    };

    const getAnsweredCount = () => {
        return Object.keys(answers).filter(key => answers[key]).length;
    };

    const getEvetCount = () => {
        return Object.values(answers).filter(val => val === "evet").length;
    };

    const getHayirCount = () => {
        return Object.values(answers).filter(val => val === "hayir").length;
    };

    // DEBUG: Fill all questions with Hayır
    const fillAllHayir = () => {
        const allQuestionIds = allClauses.flatMap(clause => clause.questions.map(q => q.id));
        const newAnswers = {};
        allQuestionIds.forEach(id => {
            newAnswers[id] = "hayir";
        });
        setAnswers(newAnswers);
        setOrgName("Test Organization");
        setFillerName("Test User");
        if (validationError) setValidationError(null);
    };


    const [openClauses, setOpenClauses] = useState({});
    // Get all uploaded files across all questions
    const getAllUploadedFiles = () => {
        const allFiles = [];
        Object.entries(files).forEach(([questionId, questionFiles]) => {
            if (questionFiles && questionFiles.length > 0) {
                // Find the question text
                let questionText = "";
                let clauseTitle = "";
                for (const clause of allClauses) {
                    const question = clause.questions.find(q => q.id === questionId);
                    if (question) {
                        questionText = question.text;
                        clauseTitle = clause.title;
                        break;
                    }
                }
                questionFiles.forEach((file, idx) => {
                    allFiles.push({
                        ...file,
                        questionId,
                        questionText,
                        clauseTitle,
                        index: idx
                    });
                });
            }
        });
        return allFiles;
    };

    const totalUploadedFiles = getAllUploadedFiles().length;

    // SOA filtering
    const filteredSOAControls = soaControls.filter(control => {
        const matchesSearch = soaSearch === '' ||
            control.controlId.toLowerCase().includes(soaSearch.toLowerCase()) ||
            control.controlName.toLowerCase().includes(soaSearch.toLowerCase());

        const matchesApplicability = soaApplicabilityFilter === 'all' ||
            (soaApplicabilityFilter === 'yes' && control.applicable) ||
            (soaApplicabilityFilter === 'no' && !control.applicable);

        const matchesStatus = soaStatusFilter === 'all' || control.implementationStatus === soaStatusFilter;

        return matchesSearch && matchesApplicability && matchesStatus;
    });

    // SOA stats
    const soaStats = {
        total: soaControls.length,
        applicable: soaControls.filter(c => c.applicable).length,
        implemented: soaControls.filter(c => c.implementationStatus === 'implemented').length,
    };

    // Open edit modal
    const openSoaEditModal = (control) => {
        setSoaEditModal(control.id);
        setSoaEditData({
            ...control,
            soaId: control.soaId || control.id,
            riskIds: control.riskIds || []
        });
        setNewRiskId('');
    };

    // Close edit modal
    const closeSoaEditModal = () => {
        setSoaEditModal(null);
        setSoaEditData(null);
        setNewRiskId('');
    };

    // Save SOA control changes
    const saveSoaControl = async () => {
        if (!soaEditData) return;

        setSoaSaving(true);
        try {
            // Extract risk IDs as numbers
            const riskIdNumbers = (soaEditData.riskIds || []).map(riskId => {
                const num = parseInt(riskId.replace('RISK-', ''));
                return isNaN(num) ? null : num;
            }).filter(id => id !== null);

            // Call API to update
            await updateSOAControlFN(soaEditData.soaId || soaEditData.id, {
                applicable: soaEditData.applicable,
                justification: soaEditData.justification,
                implementation_status: soaEditData.implementationStatus,
                risk_ids: riskIdNumbers
            });

            // Update local state
            setSoaControls(prev => prev.map(c =>
                c.id === soaEditData.id ? soaEditData : c
            ));
            closeSoaEditModal();
        } catch (error) {
            console.error("Error saving SOA control:", error);
            alert("Kontrol kaydedilirken bir hata oluştu.");
        } finally {
            setSoaSaving(false);
        }
    };

    // Add risk ID to edit data
    const addRiskIdToEdit = () => {
        if (newRiskId.trim() && soaEditData) {
            const riskIdUpper = newRiskId.trim().toUpperCase();
            if (!soaEditData.riskIds.includes(riskIdUpper)) {
                setSoaEditData(prev => ({
                    ...prev,
                    riskIds: [...prev.riskIds, riskIdUpper]
                }));
            }
            setNewRiskId('');
        }
    };

    // Remove risk ID from edit data
    const removeRiskIdFromEdit = (riskId) => {
        if (soaEditData) {
            setSoaEditData(prev => ({
                ...prev,
                riskIds: prev.riskIds.filter(id => id !== riskId)
            }));
        }
    };

    const allClauses = useMemo(() => {
        //console.log("templatesRaw ", templatesRaw)
        //console.log("selectedTemplateId ", selectedTemplateId)
        if (!templatesRaw || !selectedTemplateId) return [];

        const t = (templatesRaw || []).find(
            (x) => Number(x.template_id) === Number(selectedTemplateId)
        );

        if (!t) return [];

        const tj =
            typeof t.template_json === "string"
                ? JSON.parse(t.template_json)
                : t.template_json;

        return tj?.clauses || [];
    }, [templatesRaw, selectedTemplateId]);


    useEffect(() => {
        if (!selectedTemplateId && templatesRaw?.length) {
            setSelectedTemplateId(templatesRaw[0].template_id);
        }
    }, [templatesRaw, selectedTemplateId]);


    const [templateQuery, setTemplateQuery] = useState("");
    const [statusFilter, setStatusFilter] = useState("all");
    const [typeFilter, setTypeFilter] = useState("all");
    const [viewMode, setViewMode] = useState("grid"); // "grid" | "table"


    const templatesWithStats = useMemo(() => {
        const safeParse = (v) => {
            try { return typeof v === "string" ? JSON.parse(v) : v; }
            catch { return null; }
        };

        const estimateTime = (qCount) => {
            // simple heuristic: ~0.8–1.15 minutes per question
            const min = Math.max(5, Math.round(qCount * 0.8));
            const max = Math.max(min + 5, Math.round(qCount * 1.15));
            return `${min}-${max} minutes`;
        };

        return (templatesRaw || []).map((t) => {
            const tj = safeParse(t.template_json);
            const clauses = tj?.clauses || [];
            const questionCount = clauses.reduce(
                (sum, c) => sum + (c?.questions?.length || 0),
                0
            );

            return {
                ...t,
                clausesCount: clauses.length,
                questionCount,
                timeEstimate: estimateTime(questionCount),
                statusLabel: t.unlocked ? "Active" : "Draft",
                statusKey: t.unlocked ? "active" : "draft",
            };
        });
    }, [templatesRaw]);


    const filteredTemplates = useMemo(() => {
        const q = templateQuery.trim().toLowerCase();

        return (templatesWithStats || []).filter((t) => {
            if (q) {
                const hay = `${t.name ?? ""} ${t.description ?? ""}`.toLowerCase();
                if (!hay.includes(q)) return false;
            }

            if (statusFilter !== "all" && t.statusKey !== statusFilter) return false;

            // keep your current typeFilter behavior for now (name-based)
            if (typeFilter !== "all") {
                const name = (t.name || "").toLowerCase();
                if (!name.includes(typeFilter)) return false;
            }

            return true;
        });
    }, [templatesWithStats, templateQuery, statusFilter, typeFilter]);








    const handleDeploy = async (t) => {
        //console.log("Deploy clicked for:", t);

        try {
            const payload = {
                template_id: t.template_id ?? t.id,
                name: t.name
            };

            const res = await deploySurveyTemplateFN(payload);
            //console.log("Deploy success:", res);
            getSurveyFilesFN()
            // optional:    
            // toast.success("Template deployed");
            // navigate(`/surveys/${res.surveyId}`);
        } catch (err) {
            console.error("Deploy failed", err);
        }
    };


    return token ? (
        <div className="w-full h-screen flex flex-col overflow-x-hidden">
            {/* Top bar */}
            <div className="flex-shrink-0">
                <TopBar />
            </div>

            {/* Main area: sidebar + scrollable content */}
            <div className="flex flex-1 overflow-hidden">
                {/* Sidebar */}
                <div className="flex-shrink-0 h-full">
                    <Sidebar className="h-full" />
                </div>

                {/* MAIN SCROLL AREA */}
                <div className="flex-1 overflow-y-auto" ref={scrollContainerRef}>
                    <div className="w-full max-w-[1450px] mx-auto px-4 pb-6 pt-6">

                        {/* LOADING STATE */}
                        {loading ? (
                            <div className="flex items-center justify-center py-20">
                                <img src={LOADER} alt="Loading..." className="w-12 h-12" />
                            </div>
                        ) : (
                            <>
                                {/* Header */}
                                <div className="mb-6">
                                    <h1 className="text-2xl md:text-3xl font-bold text-[#0E0E0E] mb-3">
                                        ISO 27001:2022 Ön Değerlendirme Anketi
                                    </h1>
                                    <p className="text-gray-600 leading-relaxed">
                                        {alreadySubmitted || currentView === 'success'
                                            ? "Anketiniz başarıyla gönderilmiştir. Aşağıdaki sekmelerden detayları görüntüleyebilirsiniz."
                                            : "Lütfen organizasyonunuzun ISO 27001:2022 gerekliliklerine göre mevcut durumunu değerlendiriniz."}
                                    </p>
                                </div>




                                {/* Main Tabs - Always Visible */}
                                <div className="flex items-center gap-0 border-b border-gray-200 mb-6 bg-white rounded-t-lg">
                                    <button
                                        onClick={() => setActiveTab('survey')}
                                        className={`px-6 py-3 text-sm font-medium border-b-2 transition-colors flex items-center gap-2 ${activeTab === 'survey'
                                            ? 'border-blue-600 text-blue-600'
                                            : 'border-transparent text-gray-500 hover:text-gray-700'
                                            }`}
                                    >
                                        <IoClipboardOutline size={18} />
                                        Anket
                                        {(alreadySubmitted || currentView === 'success') && (
                                            <span className="text-green-500">✓</span>
                                        )}

                                    </button>
                                    <button
                                        onClick={() => setActiveTab('files')}
                                        className={`px-6 py-3 text-sm font-medium border-b-2 transition-colors flex items-center gap-2 ${activeTab === 'files'
                                            ? 'border-blue-600 text-blue-600'
                                            : 'border-transparent text-gray-500 hover:text-gray-700'
                                            }`}
                                    >
                                        <IoFolderOpenOutline size={18} />
                                        Dosyalar
                                        {totalUploadedFiles > 0 && (
                                            <span className="bg-blue-100 text-blue-600 px-2 py-0.5 rounded-full text-xs">
                                                {totalUploadedFiles}
                                            </span>
                                        )}
                                    </button>
                                    <button
                                        onClick={() => setActiveTab('soa')}
                                        className={`px-6 py-3 text-sm font-medium border-b-2 transition-colors flex items-center gap-2 ${activeTab === 'soa'
                                            ? 'border-blue-600 text-blue-600'
                                            : 'border-transparent text-gray-500 hover:text-gray-700'
                                            }`}
                                    >
                                        <IoGridOutline size={18} />
                                        SOA Tablosu
                                    </button>
                                    <button
                                        onClick={() => setActiveTab('results')}
                                        className={`px-6 py-3 text-sm font-medium border-b-2 transition-colors flex items-center gap-2 ${activeTab === 'results'
                                            ? 'border-blue-600 text-blue-600'
                                            : 'border-transparent text-gray-500 hover:text-gray-700'
                                            }`}
                                    >
                                        <IoBarChartOutline size={18} />
                                        Sonuçlar
                                    </button>

                                        <button
                                            onClick={() => setActiveTab('deployments')}
                                            className={`px-6 py-3 text-sm font-medium border-b-2 transition-colors flex items-center gap-2 ${activeTab === 'deployments'
                                                    ? 'border-blue-600 text-blue-600'
                                                    : 'border-transparent text-gray-500 hover:text-gray-700'
                                                }`}
                                        >
                                            <IoRocketOutline size={18} />
                                            Deployments
                                        </button>


                                    <button
                                        onClick={() => setActiveTab('templates')}
                                        className={`px-6 py-3 text-sm font-medium border-b-2 transition-colors flex items-center gap-2 ${activeTab === 'templates'
                                            ? 'border-blue-600 text-blue-600'
                                            : 'border-transparent text-gray-500 hover:text-gray-700'
                                            }`}
                                    >
                                        <IoLayersOutline size={18} />
                                        Templates
                                    </button>

                                </div>

                                {/* TAB CONTENT */}

                                {/* FILES TAB */}
                                {activeTab === 'files' && (
                                    <div className="bg-white rounded-lg border border-gray-200 shadow-sm">
                                        <div className="p-6 border-b border-gray-200">
                                            <h2 className="text-lg font-semibold text-gray-800">Yüklenen Dosyalar</h2>
                                            <p className="text-sm text-gray-500 mt-1">
                                                Anket sorularına yüklediğiniz tüm kanıt dosyaları
                                            </p>
                                        </div>
                                        {getAllUploadedFiles().length === 0 ? (
                                            <div className="p-12 text-center">
                                                <HiOutlineDocumentText className="mx-auto text-gray-300" size={48} />
                                                <p className="text-gray-500 mt-4">Henüz dosya yüklenmedi</p>
                                                <p className="text-sm text-gray-400 mt-1">
                                                    "Evet" cevabı verdiğiniz sorulara kanıt dosyaları yükleyebilirsiniz
                                                </p>
                                            </div>
                                        ) : (
                                            <div className="overflow-x-auto">
                                                <table className="w-full">
                                                    <thead className="bg-gray-50">
                                                        <tr>
                                                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                                Dosya Adı
                                                            </th>
                                                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                                Boyut
                                                            </th>
                                                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                                Soru
                                                            </th>
                                                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                                Madde
                                                            </th>
                                                            <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                                İşlemler
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody className="divide-y divide-gray-200">
                                                        {getAllUploadedFiles().map((file, idx) => (
                                                            <tr key={`${file.questionId}-${idx}`} className="hover:bg-gray-50">
                                                                <td className="px-6 py-4 whitespace-nowrap">
                                                                    <div className="flex items-center gap-2">
                                                                        <HiOutlineDocumentText className="text-gray-400" size={20} />
                                                                        <span className="text-sm font-medium text-gray-900">
                                                                            {file.name}
                                                                        </span>
                                                                        {file.uploaded && (
                                                                            <span className="text-xs text-green-600">✓</span>
                                                                        )}
                                                                    </div>
                                                                </td>
                                                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                                                    {file.size ? `${(file.size / 1024).toFixed(1)} KB` : '-'}
                                                                </td>
                                                                <td className="px-6 py-4">
                                                                    <p className="text-sm text-gray-700 line-clamp-2 max-w-md">
                                                                        {file.questionText}
                                                                    </p>
                                                                </td>
                                                                <td className="px-6 py-4 whitespace-nowrap">
                                                                    <span className="text-xs bg-gray-100 text-gray-600 px-2 py-1 rounded">
                                                                        {file.clauseTitle.split(' – ')[0]}
                                                                    </span>
                                                                </td>
                                                                <td className="px-6 py-4 whitespace-nowrap text-right">
                                                                    <div className="flex items-center justify-end gap-2">
                                                                        {file.url && (
                                                                            <a
                                                                                href={file.url}
                                                                                target="_blank"
                                                                                rel="noopener noreferrer"
                                                                                className="text-blue-600 hover:text-blue-800 text-sm font-medium"
                                                                            >
                                                                                Görüntüle
                                                                            </a>
                                                                        )}
                                                                        {!alreadySubmitted && currentView !== 'success' && (
                                                                            <button
                                                                                onClick={async () => {
                                                                                    // Delete from backend if file has an ID
                                                                                    if (file.id) {
                                                                                        try {
                                                                                            await deleteSurveyFileFN(file.id);
                                                                                        } catch (error) {
                                                                                            console.error("Error deleting file:", error);
                                                                                        }
                                                                                    }
                                                                                    // Remove from local state
                                                                                    const questionFiles = files[file.questionId];
                                                                                    const newFiles = questionFiles.filter((_, i) => i !== file.index);
                                                                                    handleFilesChange(file.questionId, newFiles);
                                                                                }}
                                                                                className="text-red-500 hover:text-red-700 text-sm font-medium"
                                                                            >
                                                                                Sil
                                                                            </button>
                                                                        )}
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                        )}
                                    </div>
                                )}

                                {/* SOA TABLOSU TAB */}
                                {activeTab === 'soa' && (
                                    <>
                                        {/* Header with icon */}
                                        <div className="flex items-start gap-4 mb-6">
                                            <div className="w-14 h-14 bg-blue-50 rounded-lg flex items-center justify-center flex-shrink-0">
                                                <IoDocumentText className="text-blue-600" size={28} />
                                            </div>
                                            <div>
                                                <h2 className="text-xl font-bold text-gray-900">ISO 27001:2022 Statement of Applicability (SOA) Tablosu</h2>
                                                <p className="text-sm text-gray-600 mt-1">
                                                    Bu tablo, ISO 27001:2022 Ek A'da yer alan 93 güvenlik kontrolünü içermektedir. Her kontrol için uygulanabilirlik durumunu belirlemeli, uygulama durumunu işaretlemeli ve gerekçesini yazmalısınız.
                                                </p>
                                            </div>
                                        </div>

                                        {/* Info boxes */}
                                        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
                                            <div className="bg-blue-50 border border-blue-100 rounded-lg p-4">
                                                <div className="flex items-center gap-2 mb-1">
                                                    <span className="w-2 h-2 bg-blue-500 rounded-full"></span>
                                                    <span className="font-medium text-blue-800">Uygulanabilirlik</span>
                                                </div>
                                                <p className="text-sm text-blue-700">Her kontrolün organizasyonunuz için uygulanabilir olup olmadığını belirleyin</p>
                                            </div>
                                            <div className="bg-green-50 border border-green-100 rounded-lg p-4">
                                                <div className="flex items-center gap-2 mb-1">
                                                    <span className="w-2 h-2 bg-green-500 rounded-full"></span>
                                                    <span className="font-medium text-green-800">Uygulama Durumu</span>
                                                </div>
                                                <p className="text-sm text-green-700">Uygulanabilir kontrollerin mevcut uygulama durumunu işaretleyin</p>
                                            </div>
                                            <div className="bg-amber-50 border border-amber-100 rounded-lg p-4">
                                                <div className="flex items-center gap-2 mb-1">
                                                    <span className="w-2 h-2 bg-amber-500 rounded-full"></span>
                                                    <span className="font-medium text-amber-800">Gerekçe</span>
                                                </div>
                                                <p className="text-sm text-amber-700">Kararınızın gerekçesini ve detaylarını açıklayın</p>
                                            </div>
                                        </div>

                                        {/* Stats */}
                                        <div className="flex items-center gap-6 mb-6 text-sm">
                                            <div>
                                                <span className="text-gray-500">Toplam Kontrol:</span>
                                                <span className="ml-2 font-semibold text-gray-900">{soaStats.total}</span>
                                            </div>
                                            <div>
                                                <span className="text-gray-500">Uygulanabilir:</span>
                                                <span className="ml-2 font-semibold text-blue-600">{soaStats.applicable}</span>
                                            </div>
                                            <div>
                                                <span className="text-gray-500">Uygulandı:</span>
                                                <span className="ml-2 font-semibold text-green-600">{soaStats.implemented}</span>
                                            </div>
                                        </div>

                                        {/* Search and filters */}
                                        <div className="flex flex-wrap items-center gap-4 mb-4">
                                            <div className="relative flex-1 min-w-[200px]">
                                                <IoSearch className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={18} />
                                                <input
                                                    type="text"
                                                    value={soaSearch}
                                                    onChange={(e) => setSoaSearch(e.target.value)}
                                                    placeholder="Kontrol ara..."
                                                    className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                                                />
                                            </div>
                                            <select
                                                value={soaApplicabilityFilter}
                                                onChange={(e) => setSoaApplicabilityFilter(e.target.value)}
                                                className="px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm bg-white"
                                            >
                                                <option value="all">Tüm Uygulanabilirlik</option>
                                                <option value="yes">Evet</option>
                                                <option value="no">Hayır</option>
                                            </select>
                                            <select
                                                value={soaStatusFilter}
                                                onChange={(e) => setSoaStatusFilter(e.target.value)}
                                                className="px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm bg-white"
                                            >
                                                <option value="all">Tüm Uygulama Durumu</option>
                                                {implementationStatusOptions.map(opt => (
                                                    <option key={opt.value} value={opt.value}>{opt.label}</option>
                                                ))}
                                            </select>
                                        </div>

                                        {/* Table */}
                                        {soaLoading ? (
                                            <div className="bg-white rounded-lg border border-gray-200 p-12 text-center">
                                                <img src={LOADER} alt="Loading..." className="w-12 h-12 mx-auto" />
                                                <p className="text-gray-500 mt-4">SOA kontrolleri yükleniyor...</p>
                                            </div>
                                        ) : (
                                            <div className="bg-white rounded-lg border border-gray-200 overflow-hidden">
                                                <div className="overflow-x-auto">
                                                    <table className="w-full">
                                                        <thead className="bg-gray-50 border-b border-gray-200">
                                                            <tr>
                                                                <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider w-12">#</th>
                                                                <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider w-24">Kontrol ID</th>
                                                                <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">Kontrol Adı</th>
                                                                <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider w-32">Kategori</th>
                                                                <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider w-32">Risk ID'leri</th>
                                                                <th className="px-4 py-3 text-center text-xs font-semibold text-gray-600 uppercase tracking-wider w-28">Uygulanabilir</th>
                                                                <th className="px-4 py-3 text-center text-xs font-semibold text-gray-600 uppercase tracking-wider w-36">Uygulama Durumu</th>
                                                                <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider w-32">Gerekçe</th>
                                                                <th className="px-4 py-3 text-center text-xs font-semibold text-gray-600 uppercase tracking-wider w-20">İşlemler</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody className="divide-y divide-gray-100">
                                                            {filteredSOAControls.map((control, index) => (
                                                                <tr key={control.id} className="hover:bg-gray-50">
                                                                    <td className="px-4 py-3 text-sm text-gray-500">{index + 1}</td>
                                                                    <td className="px-4 py-3 text-sm font-medium text-gray-900">{control.controlId}</td>
                                                                    <td className="px-4 py-3 text-sm text-gray-700">{control.controlName}</td>
                                                                    <td className="px-4 py-3">
                                                                        <span className={`inline-flex px-2 py-1 text-xs font-medium rounded border ${getCategoryBadgeClass(control.category)}`}>
                                                                            {control.category}
                                                                        </span>
                                                                    </td>
                                                                    <td className="px-4 py-3">
                                                                        <div className="flex flex-wrap gap-1">
                                                                            {control.riskIds && control.riskIds.length > 0 ? (
                                                                                <>
                                                                                    {control.riskIds.slice(0, 2).map(riskId => (
                                                                                        <span key={riskId} className="inline-flex px-2 py-0.5 text-xs font-medium rounded bg-blue-50 text-blue-600 border border-blue-200">
                                                                                            {riskId}
                                                                                        </span>
                                                                                    ))}
                                                                                    {control.riskIds.length > 2 && (
                                                                                        <span className="inline-flex px-2 py-0.5 text-xs font-medium rounded bg-gray-100 text-gray-600">
                                                                                            +{control.riskIds.length - 2}
                                                                                        </span>
                                                                                    )}
                                                                                </>
                                                                            ) : (
                                                                                <span className="text-xs text-gray-400 italic">Risk atanmadı</span>
                                                                            )}
                                                                        </div>
                                                                    </td>
                                                                    <td className="px-4 py-3 text-center">
                                                                        <span className={`inline-flex px-3 py-1 text-xs font-medium rounded ${control.applicable ? 'bg-green-100 text-green-700' : 'bg-gray-100 text-gray-600'}`}>
                                                                            {control.applicable ? 'Evet' : 'Hayır'}
                                                                        </span>
                                                                    </td>
                                                                    <td className="px-4 py-3 text-center">
                                                                        <span className={`inline-flex px-3 py-1 text-xs font-medium rounded ${getImplementationStatusDisplay(control.implementationStatus).color}`}>
                                                                            {getImplementationStatusDisplay(control.implementationStatus).label}
                                                                        </span>
                                                                    </td>
                                                                    <td className="px-4 py-3 text-sm text-gray-500">
                                                                        {control.justification ? (
                                                                            <span className="line-clamp-1">{control.justification}</span>
                                                                        ) : (
                                                                            <span className="text-gray-400 italic">Gerekçe belirtilmedi</span>
                                                                        )}
                                                                    </td>
                                                                    <td className="px-4 py-3 text-center">
                                                                        <button
                                                                            onClick={() => openSoaEditModal(control)}
                                                                            className="p-2 text-gray-500 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition-colors"
                                                                        >
                                                                            <FiEdit2 size={16} />
                                                                        </button>
                                                                    </td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        )}

                                        {/* Edit Modal */}
                                        {soaEditModal && soaEditData && (
                                            <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
                                                <div className="bg-white rounded-xl shadow-2xl w-full max-w-2xl max-h-[90vh] overflow-y-auto">
                                                    {/* Modal Header */}
                                                    <div className="flex items-center justify-between p-6 border-b border-gray-200">
                                                        <div>
                                                            <h3 className="text-lg font-semibold text-gray-900">Kontrolü Düzenle</h3>
                                                            <p className="text-sm text-gray-500 mt-0.5">{soaEditData.controlId} - {soaEditData.controlName}</p>
                                                        </div>
                                                        <button
                                                            onClick={closeSoaEditModal}
                                                            className="p-2 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-lg transition-colors"
                                                        >
                                                            <IoClose size={24} />
                                                        </button>
                                                    </div>

                                                    {/* Modal Body */}
                                                    <div className="p-6 space-y-6">
                                                        {/* Description */}
                                                        <div className="bg-blue-50 border border-blue-100 rounded-lg p-4">
                                                            <h4 className="text-sm font-medium text-blue-800 mb-2">Kontrol Açıklaması</h4>
                                                            <p className="text-sm text-blue-700">{soaEditData.description}</p>
                                                        </div>

                                                        {/* Category */}
                                                        <div>
                                                            <label className="block text-sm font-medium text-gray-700 mb-2">Kategori</label>
                                                            <span className={`inline-flex px-3 py-1.5 text-sm font-medium rounded border ${getCategoryBadgeClass(soaEditData.category)}`}>
                                                                {soaEditData.category}
                                                            </span>
                                                        </div>

                                                        {/* Applicable */}
                                                        <div>
                                                            <label className="block text-sm font-medium text-gray-700 mb-2">Kuruluş İçin Uygulanabilir</label>
                                                            <select
                                                                value={soaEditData.applicable ? 'yes' : 'no'}
                                                                onChange={(e) => setSoaEditData(prev => ({ ...prev, applicable: e.target.value === 'yes' }))}
                                                                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                                            >
                                                                <option value="yes">Evet - Bu kontrol uygulanabilir</option>
                                                                <option value="no">Hayır - Bu kontrol uygulanabilir değil</option>
                                                            </select>
                                                        </div>

                                                        {/* Implementation Status */}
                                                        <div>
                                                            <label className="block text-sm font-medium text-gray-700 mb-2">Uygulama Durumu</label>
                                                            <select
                                                                value={soaEditData.implementationStatus}
                                                                onChange={(e) => setSoaEditData(prev => ({ ...prev, implementationStatus: e.target.value }))}
                                                                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                                            >
                                                                {implementationStatusOptions.map(opt => (
                                                                    <option key={opt.value} value={opt.value}>{opt.label}</option>
                                                                ))}
                                                            </select>
                                                        </div>

                                                        {/* Justification */}
                                                        <div>
                                                            <label className="block text-sm font-medium text-gray-700 mb-2">Gerekçe / Yorumlar</label>
                                                            <textarea
                                                                value={soaEditData.justification}
                                                                onChange={(e) => setSoaEditData(prev => ({ ...prev, justification: e.target.value }))}
                                                                rows={4}
                                                                placeholder="Uygulanabilirlik durumu ve uygulama detayları için gerekçe belirtin..."
                                                                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent resize-none"
                                                            />
                                                        </div>

                                                        {/* Risk IDs */}
                                                        <div>
                                                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                                                Risk Kimlikleri <span className="text-gray-400 font-normal">(Bu kontrolün hangi riskler için uygulandığını belirtin)</span>
                                                            </label>
                                                            <div className="flex gap-2">
                                                                <select
                                                                    value={newRiskId}
                                                                    onChange={(e) => setNewRiskId(e.target.value)}
                                                                    className="flex-1 px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent bg-white"
                                                                >
                                                                    <option value="">Risk seçin...</option>
                                                                    {allRisks.filter(risk =>
                                                                        !soaEditData.riskIds?.includes(`RISK-${String(risk.ID).padStart(3, '0')}`)
                                                                    ).map(risk => (
                                                                        <option key={risk.ID} value={`RISK-${String(risk.ID).padStart(3, '0')}`}>
                                                                            RISK-{String(risk.ID).padStart(3, '0')} - {risk.Title || 'İsimsiz Risk'}
                                                                        </option>
                                                                    ))}
                                                                </select>
                                                                <button
                                                                    onClick={addRiskIdToEdit}
                                                                    disabled={!newRiskId}
                                                                    className="px-4 py-2 bg-blue-600 text-white font-medium rounded-lg hover:bg-blue-700 transition-colors disabled:bg-gray-300 disabled:cursor-not-allowed"
                                                                >
                                                                    Ekle
                                                                </button>
                                                            </div>
                                                            {allRisks.length === 0 && (
                                                                <p className="text-sm text-gray-400 mt-2 italic">Henüz risk tanımlanmamış</p>
                                                            )}
                                                            {soaEditData.riskIds && soaEditData.riskIds.length > 0 && (
                                                                <div className="flex flex-wrap gap-2 mt-3">
                                                                    {soaEditData.riskIds.map(riskId => {
                                                                        // Try to find the risk name
                                                                        const riskNum = parseInt(riskId.replace('RISK-', ''));
                                                                        const matchedRisk = allRisks.find(r => r.ID === riskNum);
                                                                        const riskName = matchedRisk?.Title || '';
                                                                        return (
                                                                            <span key={riskId} className="inline-flex items-center gap-1 px-3 py-1 text-sm font-medium rounded-full bg-blue-50 text-blue-600 border border-blue-200">
                                                                                {riskId}{riskName && ` - ${riskName.substring(0, 30)}${riskName.length > 30 ? '...' : ''}`}
                                                                                <button
                                                                                    onClick={() => removeRiskIdFromEdit(riskId)}
                                                                                    className="text-blue-400 hover:text-blue-700"
                                                                                >
                                                                                    <IoClose size={16} />
                                                                                </button>
                                                                            </span>
                                                                        );
                                                                    })}
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>

                                                    {/* Modal Footer */}
                                                    <div className="flex items-center justify-end gap-3 p-6 border-t border-gray-200 bg-gray-50">
                                                        <button
                                                            onClick={closeSoaEditModal}
                                                            disabled={soaSaving}
                                                            className="px-6 py-2.5 text-gray-700 font-medium rounded-lg border border-gray-300 hover:bg-gray-100 transition-colors disabled:opacity-50"
                                                        >
                                                            İptal
                                                        </button>
                                                        <button
                                                            onClick={saveSoaControl}
                                                            disabled={soaSaving}
                                                            className="px-6 py-2.5 bg-blue-600 text-white font-medium rounded-lg hover:bg-blue-700 transition-colors flex items-center gap-2 disabled:opacity-50"
                                                        >
                                                            {soaSaving ? (
                                                                <>
                                                                    <svg className="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                                                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                                                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                                                    </svg>
                                                                    Kaydediliyor...
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <IoSaveOutline size={18} />
                                                                    Değişiklikleri Kaydet
                                                                </>
                                                            )}
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </>
                                )}

                                {/* SONUÇLAR TAB */}
                                {activeTab === 'results' && (
                                    <div className="space-y-6">
                                        {alreadySubmitted || currentView === 'success' ? (
                                            <>
                                                {/* Compliance Score Card */}
                                                <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-6">
                                                    <div className="flex items-center justify-between mb-4">
                                                        <div>
                                                            <h2 className="text-lg font-semibold text-gray-800">Uyumluluk Skoru</h2>
                                                            <p className="text-sm text-gray-500">ISO 27001:2022 Ön Değerlendirme</p>
                                                        </div>
                                                        {submittedSurvey && (
                                                            <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-green-100 text-green-800">
                                                                Gönderildi
                                                            </span>
                                                        )}
                                                    </div>
                                                    <div className="flex items-center gap-8">
                                                        <div className="relative w-32 h-32">
                                                            <svg className="w-32 h-32 transform -rotate-90">
                                                                <circle cx="64" cy="64" r="56" stroke="#e5e7eb" strokeWidth="12" fill="none" />
                                                                <circle
                                                                    cx="64" cy="64" r="56"
                                                                    stroke={getEvetCount() / getTotalQuestions() >= 0.7 ? "#22c55e" : getEvetCount() / getTotalQuestions() >= 0.4 ? "#f59e0b" : "#ef4444"}
                                                                    strokeWidth="12"
                                                                    fill="none"
                                                                    strokeDasharray={`${(getEvetCount() / getTotalQuestions()) * 351.86} 351.86`}
                                                                    strokeLinecap="round"
                                                                />
                                                            </svg>
                                                            <div className="absolute inset-0 flex items-center justify-center">
                                                                <span className="text-2xl font-bold text-gray-800">
                                                                    {Math.round((getEvetCount() / getTotalQuestions()) * 100)}%
                                                                </span>
                                                            </div>
                                                        </div>
                                                        <div className="flex-1 grid grid-cols-3 gap-4">
                                                            <div className="bg-blue-50 rounded-lg p-4 text-center">
                                                                <p className="text-3xl font-bold text-blue-700">{getTotalQuestions()}</p>
                                                                <p className="text-sm text-blue-600 font-medium">Toplam Soru</p>
                                                            </div>
                                                            <div className="bg-green-50 rounded-lg p-4 text-center">
                                                                <p className="text-3xl font-bold text-green-700">{getEvetCount()}</p>
                                                                <p className="text-sm text-green-600 font-medium">Evet</p>
                                                            </div>
                                                            <div className="bg-red-50 rounded-lg p-4 text-center">
                                                                <p className="text-3xl font-bold text-red-700">{getHayirCount()}</p>
                                                                <p className="text-sm text-red-600 font-medium">Hayır</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* Submission Info */}
                                                {submittedSurvey && (
                                                    <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-6">
                                                        <h3 className="text-md font-semibold text-gray-800 mb-4">Gönderim Bilgileri</h3>
                                                        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                                                            <div>
                                                                <p className="text-xs text-gray-500 uppercase tracking-wider">Organizasyon</p>
                                                                <p className="text-sm font-medium text-gray-800">{submittedSurvey.organizationName}</p>
                                                            </div>
                                                            <div>
                                                                <p className="text-xs text-gray-500 uppercase tracking-wider">Gönderen</p>
                                                                <p className="text-sm font-medium text-gray-800">{submittedSurvey.fillerName}</p>
                                                            </div>
                                                            <div>
                                                                <p className="text-xs text-gray-500 uppercase tracking-wider">Gönderim Tarihi</p>
                                                                <p className="text-sm font-medium text-gray-800">
                                                                    {new Date(submittedSurvey.submittedAt).toLocaleDateString('tr-TR', {
                                                                        day: '2-digit',
                                                                        month: '2-digit',
                                                                        year: 'numeric',
                                                                        hour: '2-digit',
                                                                        minute: '2-digit'
                                                                    })}
                                                                </p>
                                                            </div>
                                                            <div>
                                                                <p className="text-xs text-gray-500 uppercase tracking-wider">Yüklenen Dosya</p>
                                                                <p className="text-sm font-medium text-gray-800">{getAllUploadedFiles().length} dosya</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}

                                                {/* Clause-by-Clause Breakdown */}
                                                <div className="bg-white rounded-lg border border-gray-200 shadow-sm">
                                                    <div className="p-6 border-b border-gray-200">
                                                        <h3 className="text-md font-semibold text-gray-800">Madde Bazında Sonuçlar</h3>
                                                    </div>
                                                    <div className="divide-y divide-gray-100">
                                                        {allClauses.map(clause => {
                                                            const clauseQuestions = clause.questions.length;
                                                            const clauseEvet = clause.questions.filter(q => answers[q.id] === 'evet').length;
                                                            const clauseHayir = clause.questions.filter(q => answers[q.id] === 'hayir').length;
                                                            const clausePercent = clauseQuestions > 0 ? Math.round((clauseEvet / clauseQuestions) * 100) : 0;

                                                            return (
                                                                <div key={clause.id} className="p-4 hover:bg-gray-50">
                                                                    <div className="flex items-center justify-between mb-2">
                                                                        <span className="text-sm font-medium text-gray-800">{clause.title}</span>
                                                                        <span className={`text-sm font-semibold ${clausePercent >= 70 ? 'text-green-600' : clausePercent >= 40 ? 'text-amber-600' : 'text-red-600'}`}>
                                                                            {clausePercent}%
                                                                        </span>
                                                                    </div>
                                                                    <div className="w-full bg-gray-200 rounded-full h-2 mb-2">
                                                                        <div
                                                                            className={`h-2 rounded-full ${clausePercent >= 70 ? 'bg-green-500' : clausePercent >= 40 ? 'bg-amber-500' : 'bg-red-500'}`}
                                                                            style={{ width: `${clausePercent}%` }}
                                                                        ></div>
                                                                    </div>
                                                                    <div className="flex items-center gap-4 text-xs text-gray-500">
                                                                        <span>{clauseQuestions} soru</span>
                                                                        <span className="text-green-600">{clauseEvet} evet</span>
                                                                        <span className="text-red-600">{clauseHayir} hayır</span>
                                                                    </div>
                                                                </div>
                                                            );
                                                        })}
                                                    </div>
                                                </div>
                                            </>
                                        ) : (
                                            <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-12 text-center">
                                                <IoStatsChart className="mx-auto text-gray-300" size={48} />
                                                <p className="text-gray-500 mt-4">Sonuçlar henüz hazır değil</p>
                                                <p className="text-sm text-gray-400 mt-1">
                                                    Anketi tamamladıktan sonra sonuçlar görüntülenebilir
                                                </p>
                                            </div>
                                        )}
                                    </div>
                                )}

                                {/* Templates TAB */}
                                {activeTab === 'templates' && (
                                    <div className="w-full min-h-screen bg-white p-6">
                                        {/* Header */}
                                        <div className="mb-5">
                                            <h1 className="text-base font-semibold text-gray-900">Survey Templates</h1>
                                            <p className="text-sm text-gray-500">Manage and organize your survey templates</p>
                                        </div>

                                        {/* Toolbar */}
                                        <div className="bg-white border border-gray-200 rounded-2xl p-4 shadow-sm">
                                            <div className="flex flex-wrap items-center gap-3">
                                                {/* Search */}
                                                <div className="relative flex-1 min-w-[320px]">
                                                    <input
                                                        value={templateQuery}
                                                        onChange={(e) => setTemplateQuery(e.target.value)}
                                                        placeholder="Search templates..."
                                                        className="
              w-full h-10 bg-[#F3F4F6] rounded-xl
              text-sm text-gray-900 placeholder:text-gray-400
              pl-10 pr-3
              outline-none border-none
              focus:outline-none focus:ring-0
            "
                                                    />
                                                    <svg
                                                        className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-500"
                                                        viewBox="0 0 24 24"
                                                        fill="none"
                                                    >
                                                        <path
                                                            d="M21 21l-4.35-4.35M10.5 18a7.5 7.5 0 1 1 0-15 7.5 7.5 0 0 1 0 15Z"
                                                            stroke="currentColor"
                                                            strokeWidth="1.5"
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                        />
                                                    </svg>
                                                </div>

                                                {/* Filters */}
                                                <div className="flex items-center gap-3">
                                                    {/* Status */}
                                                    <div className="relative">
                                                        <select
                                                            value={statusFilter}
                                                            onChange={(e) => setStatusFilter(e.target.value)}
                                                            className="
                h-10 min-w-[160px]
                bg-[#F3F4F6] rounded-xl text-sm
                px-4 pr-10
                outline-none border-none
                appearance-none
              "
                                                        >
                                                            <option value="all">All Status</option>
                                                            <option value="active">Active</option>
                                                            <option value="draft">Draft</option>
                                                            <option value="archived">Archived</option>
                                                        </select>
                                                        <svg
                                                            className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-500"
                                                            viewBox="0 0 20 20"
                                                            fill="currentColor"
                                                        >
                                                            <path d="M5.23 7.21a.75.75 0 011.06.02L10 10.94l3.71-3.71a.75.75 0 111.06 1.06l-4.24 4.24a.75.75 0 01-1.06 0L5.21 8.29a.75.75 0 01.02-1.08z" />
                                                        </svg>
                                                    </div>

                                                    {/* Type */}
                                                    <div className="relative">
                                                        <select
                                                            value={typeFilter}
                                                            onChange={(e) => setTypeFilter(e.target.value)}
                                                            className="
                h-10 min-w-[160px]
                bg-[#F3F4F6] rounded-xl text-sm
                px-4 pr-10
                outline-none border-none
                appearance-none
              "
                                                        >
                                                            <option value="all">All Types</option>
                                                            <option value="it">IT</option>
                                                            <option value="operational">Operational</option>
                                                            <option value="compliance">Compliance</option>
                                                        </select>
                                                        <svg
                                                            className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-500"
                                                            viewBox="0 0 20 20"
                                                            fill="currentColor"
                                                        >
                                                            <path d="M5.23 7.21a.75.75 0 011.06.02L10 10.94l3.71-3.71a.75.75 0 111.06 1.06l-4.24 4.24a.75.75 0 01-1.06 0L5.21 8.29a.75.75 0 01.02-1.08z" />
                                                        </svg>
                                                    </div>

                                                        {/* Grid / Table toggle */}
                                                        <div className="flex items-center border border-gray-200 rounded-xl overflow-hidden bg-white">
                                                            <button
                                                                type="button"
                                                                onClick={() => setViewMode("grid")}
                                                                className={`h-10 px-4 text-sm font-medium flex items-center gap-2 transition
    ${viewMode === "grid"
                                                                        ? "bg-gray-900 text-white"
                                                                        : "bg-white text-gray-600 hover:bg-gray-50"}`}
                                                            >
                                                                <svg
                                                                    className="w-4 h-4"
                                                                    fill="none"
                                                                    viewBox="0 0 24 24"
                                                                    stroke="currentColor"
                                                                    strokeWidth={1.75}
                                                                >
                                                                    <rect x="3" y="3" width="7" height="7" rx="1.5" />
                                                                    <rect x="14" y="3" width="7" height="7" rx="1.5" />
                                                                    <rect x="3" y="14" width="7" height="7" rx="1.5" />
                                                                    <rect x="14" y="14" width="7" height="7" rx="1.5" />
                                                                </svg>
                                                                <span className="hidden sm:inline">Grid</span>
                                                            </button>

                                                        <button
                                                            type="button"
                                                            onClick={() => setViewMode("table")}
                                                            className={`h-10 px-4 text-sm font-medium flex items-center gap-2 transition border-l border-gray-200
                ${viewMode === "table" ? "bg-gray-900 text-white" : "bg-white text-gray-600 hover:bg-gray-50"}`}
                                                        >
                                                            <span className="inline-flex items-center justify-center w-4 h-4">
                                                                ≡
                                                            </span>
                                                            Table
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Content */}
                                        <div className="mt-5">
                                            {viewMode === "grid" ? (
                                                <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-5">

                                                    {viewMode === "grid" && (
                                                        <div className="grid gap-5 [grid-template-columns:repeat(auto-fit,minmax(340px,1fr))]">

                                                            {filteredTemplates.map((t) => {
                                                                const status = t.unlocked ? "Active" : "Draft";

                                                                return (
                                                                    <div className="bg-white border border-gray-200 rounded-2xl shadow-sm p-6 min-h-[100px] flex flex-col">

                                                                        {/* Title */}
                                                                        <h3 className="text-sm font-semibold text-gray-900 mb-1">
                                                                            {t.name}
                                                                        </h3>

                                                                        {/* Status / Type pills */}
                                                                        <div className="flex items-center gap-2 mb-3">
                                                                            <span
                                                                                className={`text-xs px-2 py-0.5 rounded-full border ${t.unlocked
                                                                                        ? "bg-green-50 text-green-700 border-green-200"
                                                                                        : "bg-gray-50 text-gray-600 border-gray-200"
                                                                                    }`}
                                                                            >
                                                                                {status}
                                                                            </span>

                                                                            <span className="text-xs px-2 py-0.5 rounded-full border bg-blue-50 text-blue-700 border-blue-200">
                                                                                Template
                                                                            </span>
                                                                        </div>

                                                                        {/* Description */}
                                                                        <p className="text-sm text-gray-600 flex-1 leading-5">
                                                                            {t.description || "No description provided."}
                                                                        </p>

                                                                        <div className="mt-4 space-y-2 text-sm text-gray-600">
                                                                            {/* Questions */}
                                                                            <div className="flex items-center gap-2">
                                                                                <svg
                                                                                    className="w-4 h-4 text-gray-400"
                                                                                    fill="none"
                                                                                    viewBox="0 0 24 24"
                                                                                    stroke="currentColor"
                                                                                    strokeWidth={1.5}
                                                                                >
                                                                                    <path
                                                                                        strokeLinecap="round"
                                                                                        strokeLinejoin="round"
                                                                                        d="M8 10h8M8 14h4M6 4h12a2 2 0 012 2v12a2 2 0 01-2 2H6a2 2 0 01-2-2V6a2 2 0 012-2z"
                                                                                    />
                                                                                </svg>
                                                                                <span>{t.questionCount} questions</span>
                                                                            </div>

                                                                            {/* Time */}
                                                                            <div className="flex items-center gap-2">
                                                                                <svg
                                                                                    className="w-4 h-4 text-gray-400"
                                                                                    fill="none"
                                                                                    viewBox="0 0 24 24"
                                                                                    stroke="currentColor"
                                                                                    strokeWidth={1.5}
                                                                                >
                                                                                    <circle cx="12" cy="12" r="9" />
                                                                                    <path
                                                                                        strokeLinecap="round"
                                                                                        strokeLinejoin="round"
                                                                                        d="M12 7v5l3 3"
                                                                                    />
                                                                                </svg>
                                                                                <span>{t.timeEstimate}</span>
                                                                            </div>

                                                                            {/* Clauses */}
                                                                            <div className="flex items-center gap-2">
                                                                                <svg
                                                                                    className="w-4 h-4 text-gray-400"
                                                                                    fill="none"
                                                                                    viewBox="0 0 24 24"
                                                                                    stroke="currentColor"
                                                                                    strokeWidth={1.5}
                                                                                >
                                                                                    <path
                                                                                        strokeLinecap="round"
                                                                                        strokeLinejoin="round"
                                                                                        d="M8 6h13M8 12h13M8 18h13M3 6h.01M3 12h.01M3 18h.01"
                                                                                    />
                                                                                </svg>
                                                                                <span>{t.clausesCount} clauses</span>
                                                                            </div>
                                                                        </div>
                                                                        {/* Divider */}
                                                                        <div className="h-px bg-gray-100 my-4" />

                                                                        {/* Actions */}
                                                                        <div className="flex items-center gap-3">
                                                                            <button className="flex-1 h-9 text-sm rounded-xl border border-gray-300 hover:bg-gray-50">
                                                                                Details
                                                                            </button>

                                                                            <button
                                                                                onClick={() => handleDeploy(t)}
                                                                                className="flex-1 h-9 text-sm rounded-xl bg-gray-900 text-white hover:bg-gray-800"
                                                                            >
                                                                                Deploy
                                                                            </button>

                                                                            <button className="h-9 w-10 rounded-xl border border-gray-300 hover:bg-gray-50">
                                                                                ⋮
                                                                            </button>
                                                                        </div>
                                                                    </div>
                                                                );
                                                            })}
                                                        </div>
                                                    )}
                                                </div>
                                            ) : (

                                                <div className="bg-white border border-gray-200 rounded-2xl shadow-sm overflow-hidden">
                                                    <table className="w-full text-sm">
                                                        <thead className="bg-gray-50 text-gray-600">
                                                            <tr>
                                                                <th className="text-left font-medium px-4 py-3">Name</th>
                                                                <th className="text-left font-medium px-4 py-3">Status</th>
                                                                <th className="text-left font-medium px-4 py-3">Questions</th>
                                                                <th className="text-left font-medium px-4 py-3">Time</th>
                                                                <th className="text-left font-medium px-4 py-3">Updated</th>
                                                                <th className="text-right font-medium px-4 py-3">Actions</th>
                                                            </tr>
                                                        </thead>

                                                        <tbody className="divide-y divide-gray-100">
                                                            {filteredTemplates.map((t) => (
                                                                <tr key={t.template_id} className="hover:bg-gray-50">
                                                                    <td className="px-4 py-3">
                                                                        <div className="font-medium text-gray-900">{t.name}</div>
                                                                        {t.description && (
                                                                            <div className="text-xs text-gray-500 line-clamp-1">
                                                                                {t.description}
                                                                            </div>
                                                                        )}
                                                                    </td>

                                                                    <td className="px-4 py-3">
                                                                        <span
                                                                            className={`text-xs px-2 py-0.5 rounded-full border ${t.unlocked
                                                                                ? "bg-green-50 text-green-700 border-green-200"
                                                                                : "bg-gray-50 text-gray-600 border-gray-200"
                                                                                }`}
                                                                        >
                                                                            {t.statusLabel}
                                                                        </span>
                                                                    </td>

                                                                    <td className="px-4 py-3">{t.questionCount}</td>
                                                                    <td className="px-4 py-3">{t.timeEstimate}</td>

                                                                    <td className="px-4 py-3 text-gray-600">
                                                                        {t.updated_at ? new Date(t.updated_at).toLocaleDateString() : "—"}
                                                                    </td>

                                                                    <td className="px-4 py-3">
                                                                        <div className="flex items-center justify-end gap-2">
                                                                            <button className="h-9 px-3 rounded-xl border border-gray-300 hover:bg-gray-50">
                                                                                Details
                                                                            </button>
                                                                            <button className="h-9 px-3 rounded-xl bg-gray-900 text-white hover:bg-gray-800">
                                                                                Deploy
                                                                            </button>
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>

                                                    {filteredTemplates.length === 0 && (
                                                        <div className="p-6 text-sm text-gray-500">No templates found.</div>
                                                    )}
                                                </div>
                                            )}

                                        </div>
                                    </div>
                                )}



                                 {activeTab === "deployments" && (
  <>
    {/* Header */}
    <div className="mb-5">
      <h2 className="text-lg font-semibold text-gray-900">Survey Deployments</h2>
      <p className="text-sm text-gray-500">Track deployed surveys and response rates</p>
    </div>

    {/* List */}
    <div className="space-y-4">
      {(surveys || []).map((d) => {
        const statusLabel =
          d.status === "submitted"
            ? "Completed"
            : d.status === "draft"
            ? "Pending"
            : (d.status || "Pending");

        const progress = Number(d.progress_percent ?? 0);
        const deptCount = Number(d.departments_count ?? 1);
        const responses = Number(d.responses_count ?? 0);
        const invited = Number(d.invited_count ?? 1);

        return (
          <div
            key={d.survey_id}
            className="bg-white rounded-2xl border border-gray-200 shadow-sm overflow-hidden"
          >
            <div className="flex">
              {/* Left accent */}
              <div className="w-1.5 bg-purple-500" />

              {/* Content */}
              <div className="flex-1 px-6 py-5">
                <div className="flex items-start justify-between gap-4">
                  {/* Left: title + meta */}
                  <div className="min-w-0">
                    <div className="flex items-center gap-3">
                      <h3 className="text-sm md:text-base font-semibold text-gray-900 truncate">
                        {d.template_name || d.name || d.organization_name || "Deployment"}
                      </h3>

                      {/* Status chip */}
                      <span className="text-xs font-medium px-2.5 py-1 rounded-full border border-gray-200 bg-gray-50 text-gray-700">
                        {statusLabel}
                      </span>
                    </div>

                                {/* Meta row */}
                                <div className="mt-2 flex flex-wrap items-center gap-x-5 gap-y-2 text-sm text-gray-600">
                                    <div className="flex items-center gap-2">
                                        <Users size={14} className="text-gray-400" />
                                        <span>{deptCount} departments</span>
                                    </div>

                                    <div className="flex items-center gap-2">
                                        <Calendar size={14} className="text-gray-400" />
                                        <span>
                                            Due:{" "}
                                            {d.due_date
                                                ? new Date(d.due_date).toISOString().slice(0, 10)
                                                : "—"}
                                        </span>
                                    </div>

                                    <div className="flex items-center gap-2">
                                        <BarChart2 size={14} className="text-gray-400" />
                                        <span>
                                            {responses}/{invited} responses
                                        </span>
                                    </div>
                                </div>

                  </div>

                            {/* Right: actions */}
                            <div className="flex items-center gap-2 shrink-0">
                                <button
                                    type="button"
                                    onClick={() => handleViewDeployment(d)}
                                    className="h-9 px-3 text-sm font-medium rounded-lg border border-gray-200 bg-white text-gray-900 hover:bg-gray-50 flex items-center gap-2"
                                >
                                    <Eye size={16} />
                                    View
                                </button>

                                <button
                                    type="button"
                                    onClick={() => handleExportDeployment(d)}
                                    className="h-9 px-3 text-sm font-medium rounded-lg border border-gray-200 bg-white text-gray-900 hover:bg-gray-50 flex items-center gap-2"
                                >
                                    <Download size={16} />
                                    Export
                                </button>
                            </div>
                </div>

                {/* Progress bar */}
                <div className="mt-4">
                  <div className="h-2 w-full rounded-full bg-gray-200 overflow-hidden">
                    <div
                      className="h-2 rounded-full bg-gray-700"
                      style={{ width: `${Math.max(0, Math.min(100, progress))}%` }}
                    />
                  </div>
                  <div className="mt-2 text-xs text-gray-500">{progress}% complete</div>
                </div>
              </div>
            </div>
          </div>
        );
      })}

      {/* Empty state */}
      {(!surveys || surveys.length === 0) && (
        <div className="bg-white rounded-2xl border border-gray-200 shadow-sm p-8 text-center">
          <p className="text-sm text-gray-700 font-medium">No deployments yet</p>
          <p className="text-sm text-gray-500 mt-1">
            Deploy a survey template to start tracking responses here.
          </p>
        </div>
      )}
    </div>
  </>
)}

                                
                                {/* ANKET TAB */}
                                {activeTab === 'survey' && (
                                    <>
                                        {alreadySubmitted ? (
                                            /* ALREADY SUBMITTED - Show Summary */
                                            <div className="bg-white rounded-lg border-l-4 border-green-500 shadow-sm p-8">
                                                <div className="flex items-center gap-4 mb-6">
                                                    <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center">
                                                        <IoCheckmarkCircle className="text-green-600" size={40} />
                                                    </div>
                                                    <div>
                                                        <h2 className="text-xl font-bold text-gray-800">Anket Başarıyla Gönderildi</h2>
                                                        <p className="text-gray-600">Bu anket daha önce başarıyla gönderilmiştir.</p>
                                                    </div>


                                                </div>
                                                {submittedSurvey && (
                                                    <div className="bg-gray-50 rounded-lg p-4 space-y-2">
                                                        <p className="text-sm text-gray-600">
                                                            <span className="font-medium">Organizasyon:</span> {submittedSurvey.organizationName}
                                                        </p>
                                                        <p className="text-sm text-gray-600">
                                                            <span className="font-medium">Gönderen:</span> {submittedSurvey.fillerName}
                                                        </p>
                                                        <p className="text-sm text-gray-600">
                                                            <span className="font-medium">Gönderim Tarihi:</span> {new Date(submittedSurvey.submittedAt).toLocaleDateString('tr-TR', {
                                                                day: '2-digit',
                                                                month: '2-digit',
                                                                year: 'numeric',
                                                                hour: '2-digit',
                                                                minute: '2-digit'
                                                            })}
                                                        </p>
                                                    </div>
                                                )}
                                                <div className="mt-6">
                                                    <p className="text-sm text-gray-500">
                                                        Sonuçları görmek için "Sonuçlar" sekmesine, yüklenen dosyaları görmek için "Dosyalar" sekmesine tıklayabilirsiniz.
                                                    </p>
                                                </div>

                                            </div>
                                        ) : currentView === 'success' ? (
                                            /* SUCCESS STATE */
                                            <div className="bg-white rounded-lg border-l-4 border-green-500 shadow-sm p-8">
                                                <div className="flex items-center gap-4 mb-6">
                                                    <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center">
                                                        <IoCheckmarkCircle className="text-green-600" size={40} />
                                                    </div>
                                                    <div>
                                                        <h2 className="text-xl font-bold text-gray-800">Anket Başarıyla Gönderildi!</h2>
                                                        <p className="text-gray-600">ISO 27001:2022 Ön Değerlendirme Anketiniz başarıyla kaydedildi.</p>
                                                    </div>
                                                </div>
                                                <div className="bg-gray-50 rounded-lg p-4 space-y-2">
                                                    <p className="text-sm text-gray-600">
                                                        <span className="font-medium">Organizasyon:</span> {orgName}
                                                    </p>
                                                    <p className="text-sm text-gray-600">
                                                        <span className="font-medium">Gönderen:</span> {fillerName}
                                                    </p>
                                                    <p className="text-sm text-gray-600">
                                                        <span className="font-medium">Toplam Soru:</span> {getTotalQuestions()}
                                                    </p>
                                                    <p className="text-sm text-gray-600">
                                                        <span className="font-medium">Evet Cevapları:</span> {getEvetCount()}
                                                    </p>
                                                    <p className="text-sm text-gray-600">
                                                        <span className="font-medium">Hayır Cevapları:</span> {getHayirCount()}
                                                    </p>
                                                </div>
                                                <div className="mt-6">
                                                    <p className="text-sm text-gray-500">
                                                        Sonuçları görmek için "Sonuçlar" sekmesine, yüklenen dosyaları görmek için "Dosyalar" sekmesine tıklayabilirsiniz.
                                                    </p>
                                                </div>
                                            </div>
                                        ) : currentView === 'review' ? (
                                            /* REVIEW VIEW */
                                            <>
                                                {/* Review Header */}
                                                <div className="mb-6">
                                                    <button
                                                        onClick={handleBackToSurvey}
                                                        className="flex items-center gap-2 text-blue-600 hover:text-blue-800 mb-4 font-medium"
                                                    >
                                                        <IoArrowBack size={20} />
                                                        Ankete Geri Dön
                                                    </button>
                                                    <h1 className="text-2xl md:text-3xl font-bold text-[#0E0E0E] mb-3">
                                                        Yanıtlarınızı Gözden Geçirin
                                                    </h1>
                                                    <p className="text-gray-600 leading-relaxed">
                                                        Lütfen aşağıdaki yanıtlarınızı kontrol ediniz. Değişiklik yapmak için "Ankete Geri Dön" butonuna tıklayabilirsiniz.
                                                    </p>
                                                </div>

                                                {/* Organization Info Review */}
                                                <div className="bg-white rounded-lg border border-gray-200 shadow-sm mb-6 p-6">
                                                    <h2 className="text-lg font-semibold text-gray-800 mb-4">Organizasyon Bilgileri</h2>
                                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                                        <div>
                                                            <span className="text-sm text-gray-500">Organizasyon Adı</span>
                                                            <p className="text-gray-800 font-medium">{orgName || "-"}</p>
                                                        </div>
                                                        <div>
                                                            <span className="text-sm text-gray-500">Anketi Dolduran</span>
                                                            <p className="text-gray-800 font-medium">{fillerName || "-"}</p>
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* Summary Stats */}
                                                <div className="bg-white rounded-lg border border-gray-200 shadow-sm mb-6 p-6">
                                                    <h2 className="text-lg font-semibold text-gray-800 mb-4">Özet</h2>
                                                    <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                                                        <div className="text-center p-4 bg-gray-50 rounded-lg">
                                                            <p className="text-3xl font-bold text-gray-800">{getTotalQuestions()}</p>
                                                            <p className="text-sm text-gray-500">Toplam Soru</p>
                                                        </div>
                                                        <div className="text-center p-4 bg-blue-50 rounded-lg">
                                                            <p className="text-3xl font-bold text-blue-600">{getAnsweredCount()}</p>
                                                            <p className="text-sm text-gray-500">Cevaplanan</p>
                                                        </div>
                                                        <div className="text-center p-4 bg-green-50 rounded-lg">
                                                            <p className="text-3xl font-bold text-green-600">{getEvetCount()}</p>
                                                            <p className="text-sm text-gray-500">Evet</p>
                                                        </div>
                                                        <div className="text-center p-4 bg-red-50 rounded-lg">
                                                            <p className="text-3xl font-bold text-red-600">{getHayirCount()}</p>
                                                            <p className="text-sm text-gray-500">Hayır</p>
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* Clause Reviews */}
                                                {allClauses.map((clause) => (
                                                    <div key={clause.id} className="bg-white rounded-lg border border-gray-200 shadow-sm mb-6">
                                                        <div className="p-6 border-b border-gray-100">
                                                            <h2 className="text-lg font-semibold text-gray-800">{clause.title}</h2>
                                                            <p className="text-sm text-gray-500 mt-1">{clause.subtitle}</p>
                                                        </div>
                                                        <div className="p-6">
                                                            {clause.questions.map((question, idx) => {
                                                                const answer = answers[question.id];
                                                                const display = getAnswerDisplay(answer);
                                                                const questionFiles = files[question.id];
                                                                return (
                                                                    <div key={question.id} className="py-3 border-b border-gray-100 last:border-b-0">
                                                                        <div className="flex items-start justify-between gap-4">
                                                                            <div className="flex-1">
                                                                                <p className="text-gray-700 text-sm">
                                                                                    <span className="font-medium text-gray-500 mr-2">{idx + 1}.</span>
                                                                                    {question.text}
                                                                                </p>
                                                                                {/* Show uploaded files */}
                                                                                {questionFiles && questionFiles.length > 0 && (
                                                                                    <div className="mt-2 flex flex-wrap gap-2">
                                                                                        {questionFiles.map((file, fileIdx) => (
                                                                                            <span key={fileIdx} className="inline-flex items-center gap-1 text-xs bg-blue-50 text-blue-700 px-2 py-1 rounded">
                                                                                                <HiOutlineDocumentText size={14} />
                                                                                                {file.name}
                                                                                            </span>
                                                                                        ))}
                                                                                    </div>
                                                                                )}
                                                                            </div>
                                                                            <span className={`px-3 py-1 rounded-full text-sm font-medium ${display.bgColor} ${display.color}`}>
                                                                                {display.text}
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                );
                                                            })}
                                                        </div>
                                                    </div>
                                                ))}

                                                {/* Action Buttons */}
                                                <div className="mt-8 mb-6 flex flex-col sm:flex-row gap-4">
                                                    <button
                                                        onClick={handleBackToSurvey}
                                                        disabled={submitting}
                                                        className="flex-1 flex items-center justify-center gap-2 bg-white border border-gray-300 hover:bg-gray-50 text-gray-700 font-medium py-4 px-6 rounded-lg transition-colors text-lg disabled:opacity-50 disabled:cursor-not-allowed"
                                                    >
                                                        <FiEdit2 size={20} />
                                                        Düzenle
                                                    </button>
                                                    <button
                                                        onClick={handleFinalSubmit}
                                                        disabled={submitting}
                                                        className="flex-1 flex items-center justify-center gap-2 bg-blue-600 hover:bg-blue-700 text-white font-medium py-4 px-6 rounded-lg transition-colors text-lg disabled:opacity-50 disabled:cursor-not-allowed"
                                                    >
                                                        {submitting ? (
                                                            <>
                                                                <img src={LOADER} alt="Loading..." className="w-5 h-5" />
                                                                Gönderiliyor...
                                                            </>
                                                        ) : (
                                                            <>
                                                                <IoCheckmarkCircle size={22} />
                                                                Anketi Gönder
                                                            </>
                                                        )}
                                                    </button>
                                                </div>
                                            </>
                                        ) : (
                                            <>
                                                {/* Validation Error */}
                                                {validationError && (
                                                    <div className="mb-6 bg-red-50 border border-red-200 rounded-lg p-4 flex items-center gap-3">
                                                        <IoWarning className="text-red-500 flex-shrink-0" size={24} />
                                                        <p className="text-red-700 font-medium">{validationError}</p>
                                                    </div>
                                                )}

                                                {/* DEBUG Button - Remove in production */}
                                                {/* <button
                            onClick={fillAllHayir}
                            className="mb-4 px-4 py-2 bg-orange-500 hover:bg-orange-600 text-white text-sm font-medium rounded-lg transition-colors"
                        >
                            🐛 DEBUG: Fill All Hayır
                        </button> */}

                                                {/* Organization Information Section */}
                                                <div className="bg-white rounded-lg border border-gray-200 shadow-sm mb-6">
                                                    <div className="p-6">
                                                        <h2 className="text-lg font-semibold text-gray-800 mb-4">Organizasyon Bilgileri</h2>
                                                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                                            <div>
                                                                <label className="block text-gray-700 mb-2">
                                                                    Organizasyon Adı <span className="text-red-500">*</span>
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    value={orgName}
                                                                    onChange={(e) => {
                                                                        setOrgName(e.target.value);
                                                                        if (validationError) setValidationError(null);
                                                                    }}
                                                                    placeholder="Şirket adınızı giriniz"
                                                                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                                                />
                                                            </div>
                                                            <div>
                                                                <label className="block text-gray-700 mb-2">
                                                                    Anketi Dolduran <span className="text-red-500">*</span>
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    value={fillerName}
                                                                    onChange={(e) => {
                                                                        setFillerName(e.target.value);
                                                                        if (validationError) setValidationError(null);
                                                                    }}
                                                                    placeholder="Adınız ve soyadınız"
                                                                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="bg-white border border-gray-200 rounded-xl p-4 shadow-sm mb-4">
                                                    <div className="flex items-center gap-3">

                                                        {/* Label */}
                                                        <div className="flex items-center gap-2 shrink-0">
                                                            <svg
                                                                className="w-4 h-4 text-gray-500"
                                                                fill="none"
                                                                viewBox="0 0 24 24"
                                                                stroke="currentColor"
                                                            >
                                                                <path
                                                                    strokeWidth="1.5"
                                                                    strokeLinecap="round"
                                                                    strokeLinejoin="round"
                                                                    d="M8 7V3m8 4V3M3 11h18M5 5h14a2 2 0 012 2v12a2 2 0 01-2 2H5a2 2 0 01-2-2V7a2 2 0 012-2z"
                                                                />
                                                            </svg>
                                                            <span className="text-sm font-medium text-gray-700">
                                                                Choose survey template
                                                            </span>
                                                        </div>

                                                        {/* Select */}
                                                        <select
                                                            value={selectedTemplateId ?? ""}
                                                            onChange={(e) => setSelectedTemplateId(Number(e.target.value))}
                                                            className="
        ml-auto
        bg-[#F3F4F6] rounded-md text-xs px-3 py-2
        outline-none border-none
        focus:outline-none focus:ring-0
        min-w-[220px]
      "
                                                        >
                                                            {(templatesRaw || []).map((t) => (
                                                                <option key={t.template_id} value={t.template_id}>
                                                                    {t.name}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </div>


                                                {allClauses.map((clause) => {
                                                    const isOpen = !!openClauses?.[clause.id];
                                                    //console.log("allClauses ", allClauses)
                                                    return (
                                                        <div key={clause.id} className="bg-white rounded-lg border border-gray-200 shadow-sm mb-6">
                                                            {/* Section Header */}
                                                            <div
                                                                className="flex items-center justify-between p-6 cursor-pointer hover:bg-gray-50 transition-colors"
                                                                onClick={() =>
                                                                    setOpenClauses((prev) => ({
                                                                        ...(prev || {}),
                                                                        [clause.id]: !prev?.[clause.id],
                                                                    }))
                                                                }
                                                            >
                                                                <div>
                                                                    <h2 className="text-lg font-semibold text-gray-800">
                                                                        {clause.title} ({clause.questions?.length || 0} Soru)
                                                                    </h2>
                                                                    {clause.subtitle && (
                                                                        <p className="text-sm text-gray-500 mt-1">{clause.subtitle}</p>
                                                                    )}
                                                                </div>

                                                                {isOpen ? (
                                                                    <IoChevronUp size={24} className="text-gray-500" />
                                                                ) : (
                                                                    <IoChevronDown size={24} className="text-gray-500" />
                                                                )}
                                                            </div>

                                                            {/* Questions */}
                                                            {isOpen && (
                                                                <div className="px-6 pb-6 border-t border-gray-100">
                                                                    {(clause.questions || []).map((question) => (
                                                                        <QuestionItem
                                                                            key={question.id}
                                                                            question={question}
                                                                            answer={answers[question.id]}
                                                                            onAnswerChange={handleAnswerChange}
                                                                            files={files[question.id]}
                                                                            onFilesChange={handleFilesChange}
                                                                            onFileUpload={uploadSurveyFileFN}
                                                                            onFileRemove={deleteSurveyFileFN}
                                                                        />
                                                                    ))}
                                                                </div>
                                                            )}
                                                        </div>
                                                    );
                                                })}


                                                {/* Submit Button */}
                                                <div className="mt-8 mb-6">
                                                    <button
                                                        onClick={handleGoToReview}
                                                        className="w-full bg-blue-600 hover:bg-blue-700 text-white font-medium py-4 px-6 rounded-lg transition-colors text-lg"
                                                    >
                                                        Değerlendirmeyi Tamamla ve SOA Tablosuna Geç
                                                    </button>
                                                </div>
                                            </>
                                        )}
                                    </>
                                )}
                            </>
                        )}

                    </div>
                </div>
            </div>
        </div>
    ) : (
        <Redirect to="/login" />
    );
}

const mapStateToProps = (state) => {
    //console.log("Surveys ", state.audits?.surveys,)
    return {
        token: state.auth.token,
        allRisks: state.risk.all_risks_report || [],
        templatesRaw:  state.audits?.surveys,
        templatesRaw: state.audits?.survey_templates,
    };
};

const mapDispatchToProps = (dispatch) => ({
    checkSurveyStatusFN: () => dispatch(checkSurveyStatus()),
    submitSurveyFN: (data) => dispatch(submitSurvey(data)),
    uploadSurveyFileFN: (file, questionId) => dispatch(uploadSurveyFile(file, questionId)),
    deleteSurveyFileFN: (fileId) => dispatch(deleteSurveyFile(fileId)),
    getAllRisksFN: () => dispatch(getAllRisks_Report()),
    getSOAControlsFN: () => dispatch(getSOAControls()),
    updateSOAControlFN: (soa_id, data) => dispatch(updateSOAControl(soa_id, data)),
    getSurveyFilesFN: (surveyId, questionId) => dispatch(getSurveyFiles(surveyId, questionId)),
    getAllSurveysTemplateFN: () => dispatch(getAllSurveysTemplate()),
    getAllSurveysFN: () => dispatch(getAllSurveys()),
    deploySurveyTemplateFN:(data) => dispatch(deploySurveyTemplate(data)),
});

export default compose(connect(mapStateToProps, mapDispatchToProps))(Survey);
